(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["functions-cart-drawer-it"]) return;
  try {
    
(function () {
  function init() {
    var root = document.querySelector('[data-cart-drawer]');
    if (!root || root.dataset.fnInit) return;
    root.dataset.fnInit = '1';

    var moneyFormat = root.getAttribute('data-money-format') || '\u007B\u007Bamount\u007D\u007D';
    var fsEnabled = root.getAttribute('data-fs-enabled') === 'true';
    var fsThreshold = parseInt(root.getAttribute('data-fs-threshold'), 10) || 0;
    var fsProgressTpl = root.getAttribute('data-fs-progress') || '';
    var fsSuccessTpl = root.getAttribute('data-fs-success') || '';
    var showUnitPrice = root.getAttribute('data-show-unit-price') === 'true';
    var nightText = root.getAttribute('data-night-text') || '';
    // Preis pro Packung: Zeilenpreis geteilt durch alle Packungen (inkl. gratis).
    var packText = root.getAttribute('data-pack-text') || '';
    // Packungspreis als grosser Preis (wie auf der LP), Gesamtpreis klein darunter.
    var packHeadline = root.getAttribute('data-pack-headline') === 'true';
    var packUnit = root.getAttribute('data-pack-unit') || '';
    var packTotal = root.getAttribute('data-pack-total') || '';
    function packHtmlFor(total, qty) {
      if (!packText || qty < 2 || total <= 0) return '';
      return '<span class="fn-cart-drawer__per-pack">' + esc(packText).replace(/\[price\]/g, '<b>' + money(Math.round(total / qty)) + '</b>') + '</span>';
    }
    var nightServings = parseInt(root.getAttribute('data-night-servings'), 10) || 0;
    // Feste Paketpreise fuer den Preis pro Nacht, z. B. "1=44,95; 3=89,90"
    // (Menge=Preis in €). Ohne Eintrag zaehlt der Zeilenpreis im Warenkorb.
    var nightPrices = {};
    (root.getAttribute('data-night-prices') || '').split(';').forEach(function (part) {
      var kv = part.split('=');
      var q = parseInt(kv[0], 10);
      var cents = Math.round(parseFloat(String(kv[1] || '').replace(/[^0-9,.]/g, '').replace(/\.(?=.*,)/g, '').replace(',', '.')) * 100);
      if (q > 0 && cents > 0) nightPrices[q] = cents;
    });
    // Das Setting ist ein Textfeld, damit auch "4,95" erlaubt ist – Shopifys
    // number-Setting nimmt keine Nachkommastellen.
    var shippingCost = Math.round(
      (parseFloat(String(root.getAttribute('data-shipping-cost') || '0').replace(/\s/g, '').replace(',', '.')) || 0) * 100
    );
    var offerEnabled = root.getAttribute('data-offer-enabled') === 'true';
    var offerTimerOn = root.getAttribute('data-offer-timer') === 'true';
    var offerTimerPrefix = root.getAttribute('data-offer-timer-prefix') || '';
    var offerCode = (root.getAttribute('data-offer-code') || '').trim();
    // "2:20, 3:30" – Menge zu beworbenem Prozentsatz. Der Warenkorb weist alle
    // Nachlaesse als ein Angebot aus, deshalb steht in der Zeile die beworbene
    // Stufe und nicht die auf zwei Stellen gerechnete echte Quote.
    var offerTiers = (root.getAttribute('data-offer-tiers') || '')
      .split(',')
      .map(function (part) {
        var kv = part.split(':');
        return { qty: parseInt(kv[0], 10), pct: parseFloat(kv[1]) };
      })
      .filter(function (t) { return t.qty > 0 && t.pct > 0; })
      .sort(function (a, b) { return a.qty - b.qty; });

    var upsellFrom = parseInt(root.getAttribute('data-upsell-from'), 10) || 1;
    var upsellTo = parseInt(root.getAttribute('data-upsell-to'), 10) || 2;

    var itemsEl = root.querySelector('[data-cart-items]');
    var cardEl = root.querySelector('[data-cart-card]');
    var reviewEl = root.querySelector('[data-cart-review]');
    var emptyEl = root.querySelector('[data-cart-empty]');
    var reserveEl = root.querySelector('[data-cart-reserve]');
    var footEl = root.querySelector('[data-cart-foot]');
    var subtotalEl = root.querySelector('[data-cart-subtotal]');
    var subtotalWasEl = root.querySelector('[data-cart-subtotal-was]');
    var totalsEl = root.querySelector('.fn-cart-drawer__totals');
    var countEl = root.querySelector('[data-cart-drawer-count]');
    var shippingEl = root.querySelector('[data-cart-shipping]');
    var grandTotalEl = root.querySelector('[data-cart-grand-total]');
    var offerRowEl = root.querySelector('[data-offer-row]');
    // Texte/Regeln des neuen Drawer-Designs (alle aus den Section-Settings).
    var unitText = root.getAttribute('data-unit-text') || '';
    var tRemove = root.getAttribute('data-t-remove') || 'Rimuovi';
    var tQty = root.getAttribute('data-t-qty') || 'Qtà';
    var tGratis = root.getAttribute('data-t-gratis') || 'GRATIS';
    var shipFreeText = root.getAttribute('data-ship-free-text') || 'Gratis';
    // Gratis-Versand ab dieser Gesamtmenge (0 = Preisgrenze fs-threshold nutzen).
    var shipFreeQty = parseInt(root.getAttribute('data-ship-free-qty'), 10) || 0;
    var shipNoteEl = root.querySelector('[data-ship-note]');
    var offerAmountEl = root.querySelector('[data-offer-amount]');
    var offerLabelEl = root.querySelector('[data-offer-label]');
    var offerLabelTpl = offerLabelEl
      ? (offerLabelEl.getAttribute('data-offer-label-template') || offerLabelEl.textContent)
      : '';
    var offerTimerEl = root.querySelector('[data-offer-timer]');
    var upsellStepEl = root.querySelector('[data-upsell-step]');
    var upsellEl = root.querySelector('[data-upsell]') || upsellStepEl;
    // Angebot rechnet sich gerade? Und wurde es in dieser Sitzung schon gezeigt?
    var upsellReady = false;
    var upsellAsked = false;
    // Wie oft der Zwischenschritt pro Seitenaufruf hoechstens auftauchen darf.
    var upsellAskCount = 0;
    var upsellMaxAsks = 3;
    var checkoutHref = '/checkout';
    // Blendet den Zwischenschritt aus und gibt den Fokus an den Checkout-Button
    // zurueck, damit Tastaturnutzer nicht im ausgeblendeten Dialog stehen.
    function dismissUpsellStep() {
      if (!upsellStepEl || upsellStepEl.hidden) return;
      upsellStepEl.hidden = true;
      // Das X fuehrt zurueck in den Warenkorb, also wird beim naechsten Klick
      // auf "Zur Kasse" wieder gefragt. Wer wirklich ohne zweite Packung
      // weiter will, nimmt den Ablehnen-Link – der geht immer durch. Damit der
      // Button niemand festhaelt, ist die Zahl der Nachfragen begrenzt.
      if (upsellAskCount < upsellMaxAsks) upsellAsked = false;
      var back = root.querySelector('.fn-cart-drawer__checkout');
      if (back && typeof back.focus === 'function') back.focus();
    }
    // Feste Pakete statt freier Menge, z. B. "1:1 Packung, 3:2+1 gratis".
    var packOptions = (root.getAttribute('data-pack-options') || '')
      .split(',')
      .map(function (part) {
        var i = part.indexOf(':');
        return { qty: parseInt(part.slice(0, i), 10), label: part.slice(i + 1).trim() };
      })
      .filter(function (o) { return o.qty > 0 && o.label; });
    var packNote = root.getAttribute('data-pack-note') || '';
    var packChip = root.getAttribute('data-pack-chip') || '';
    var hideRemove = root.hasAttribute('data-hide-remove');
    var packImage = root.getAttribute('data-pack-image') || '';
    // Zaehler statt Paketknoepfen: freie Menge, darunter der Hinweis, ab
    // welcher Menge eine Packung gratis ist.
    var packCounter = packOptions.length > 0 && root.hasAttribute('data-pack-counter');
    // Alte Paket-Knoepfe (pack_style = buttons) bleiben als Legacy erhalten.
    var legacyButtons = packOptions.length > 0 && !packCounter;
    // Paket-Modus: feste Pakete (1 Monat / 3 Monate) als Karte mit klarem
    // Rabatt und Haekchen wie in der Auswahl auf der Seite.
    // Format je Paket: Menge|Name|Haekchen (mit ~ getrennt)|Preis|Statt-Preis
    function euroCents(v) {
      var n = parseFloat(String(v || '').replace(/[^0-9,.]/g, '').replace(/\.(?=.*,)/g, '').replace(',', '.'));
      return n > 0 ? Math.round(n * 100) : 0;
    }
    var bundles = (root.getAttribute('data-pack-bundles') || '').split(';').map(function (part) {
      var f = part.split('|').map(function (x) { return x.trim(); });
      return { qty: parseInt(f[0], 10), name: f[1] || '', ticks: (f[2] || '').split('~').map(function (t) { return t.trim(); }).filter(Boolean), price: euroCents(f[3]), compare: euroCents(f[4]) };
    }).filter(function (b) { return b.qty > 0 && b.name; });
    var bundleMode = root.hasAttribute('data-pack-bundles') && bundles.length > 0;
    var bundleSaveText = root.getAttribute('data-bundle-save') || '';
    var bundleSaveSingle = root.getAttribute('data-bundle-save-single') || '';
    var bundleScarcity = root.getAttribute('data-bundle-scarcity') || '';
    var freeAt = parseInt(root.getAttribute('data-free-at'), 10) || 3;
    // Zaehler zaehlt bezahlte Packungen: je buyN bezahlte gibt es 1 gratis.
    // Im Warenkorb steht die Summe aus beiden, z. B. 2 bezahlt = 3, 4 = 6.
    var buyN = Math.max(freeAt - 1, 1);
    // Hoechstzahl Gratis-Packungen je Bestellung (0 = unbegrenzt). Muss zum
    // Shopify-Rabatt passen, sonst verspricht die Karte mehr als der Checkout.
    var freeMax = parseInt(root.getAttribute('data-free-max'), 10) || 0;
    function capFree(n) { return freeMax > 0 ? Math.min(n, freeMax) : n; }
    function paidOf(qty) { return qty - capFree(Math.floor(qty / freeAt)); }
    function freeOf(paid) { return capFree(Math.floor(paid / buyN)); }
    function cartQty(paid) { return paid + freeOf(paid); }
    // Gratis-Packung als eigene Karte unter dem Produkt.
    var freeActive = root.getAttribute('data-free-active') || '';
    var freeImage = root.getAttribute('data-free-image') || '';
    // Merkt sich, welche Menge schon einmal korrigiert wurde – sonst koennte
    // eine abgelehnte Aenderung endlos neu angestossen werden.
    var normalisedQty = {};

    var topEl = root.querySelector('[data-top]');
    var sbEl = root.querySelector('[data-sb]');
    var sbText = root.querySelector('[data-sb-text]');
    var sbFill = root.querySelector('[data-sb-fill]');
    var sbTrack = root.querySelector('[data-sb-track]');
    var fsWrap = root.querySelector('[data-fs-wrap]');
    var fsLabel = root.querySelector('[data-fs-label]');
    var fsFill = root.querySelector('[data-fs-fill]');

    // ---- money formatting (Shopify standard) ----
    function formatWithDelimiters(cents, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(cents) || cents == null) cents = 0;
      var value = (cents / 100).toFixed(precision);
      var parts = value.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }
    var moneyNf = null;
    try {
      moneyNf = new Intl.NumberFormat('it-IT', { style: 'currency', currency: root.getAttribute('data-currency') || 'EUR' });
    } catch (e) { moneyNf = null; }
    function money(cents) {
      if (moneyNf && cents != null && !isNaN(cents)) return moneyNf.format(cents / 100);
      return moneyShopify(cents);
    }
    function moneyShopify(cents) {
      var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = m ? m[1] : 'amount';
      var val;
      switch (key) {
        case 'amount_no_decimals': val = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': val = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': val = formatWithDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': val = formatWithDelimiters(cents, 2, ' ', ','); break;
        case 'amount_with_apostrophe_separator': val = formatWithDelimiters(cents, 2, "'", '.'); break;
        default: val = formatWithDelimiters(cents, 2);
      }
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, val);
    }

    // Kacheln sind max. 84 px: Shopify-CDN auf 2x skalieren statt Originalbild laden.
    function thumbUrl(u) {
      if (!u || !/\/(cdn\/shop|s\/files)\//.test(u) || /[?&]width=/.test(u)) return u;
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=168';
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function setCounts(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
      if (countEl) countEl.textContent = n;
    }

    // Rabattzeile. Angezeigt wird ausschliesslich der Rabatt, den Shopify
    // wirklich auf Warenkorb-Ebene rechnet – sonst stuende hier ein Nachlass,
    // den der Checkout nicht einloest. Die Prozente selbst kommen aus einem
    // automatischen Rabatt im Shopify-Admin, nicht aus dem Theme.
    // /cart.js und /cart/change.js liefern dieselbe Information in zwei Formen:
    // einmal flach mit total_allocated_amount, einmal verschachtelt als
    // { amount, discount_application }. Beides muss gelesen werden, sonst faellt
    // die Zeile nach jeder Mengenaenderung wieder weg.
    function offerSum(cart) {
      var apps = (cart && cart.cart_level_discount_applications) || [];
      var sum = 0;
      for (var i = 0; i < apps.length; i++) {
        var a = apps[i];
        sum += a.total_allocated_amount || a.amount ||
          (a.discount_application && a.discount_application.total_allocated_amount) || 0;
      }
      return sum;
    }

    // Shopify verwirft einen Code, der auf einen Warenkorb gelegt wird, der die
    // Mindestmenge noch nicht erreicht – genau der Normalfall, wenn die Seite
    // mit leerem Warenkorb geladen und erst danach etwas hinzugefuegt wird.
    // Deshalb wird der Code nicht einmal pro Seitenaufruf gesetzt, sondern immer
    // dann erneut, wenn sich die Menge geaendert hat und noch kein Rabatt
    // gerechnet wird. Greift er, liefert der zweite Aufruf den Warenkorb mit
    // Rabatt zurueck; greift er nicht, bleibt alles wie es war.
    var offerTriedCount = -1;
    function ensureOfferCode(cart) {
      if (!offerEnabled || !offerCode) return Promise.resolve(cart);
      if (offerSum(cart) > 0) return Promise.resolve(cart);
      if (cart && cart.item_count === offerTriedCount) return Promise.resolve(cart);
      offerTriedCount = cart ? cart.item_count : -1;
      return fetch('/discount/' + encodeURIComponent(offerCode), { credentials: 'same-origin' })
        .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .catch(function () { return cart; });
    }

    // Listenpreis ohne jeden Nachlass \u2013 3 x 49,95 statt des Paketpreises.
    function fullPrice(cart) {
      var items = (cart && cart.items) || [];
      return items.reduce(function (sum, it) { return sum + it.original_line_price; }, 0);
    }

    // Normalfall sind die gepflegten Stufen: der Warenkorb soll denselben
    // gerundeten Prozentsatz nennen wie die Paketauswahl auf der PDP (20/30),
    // sonst steht ueber der Karte 20 % und darunter 19 %. Nur wenn keine Stufe
    // zur Menge passt, wird der wirklich gewaehrte Rabatt gerechnet – dann
    // abgerundet, damit nie mehr Ersparnis ausgewiesen wird, als der Checkout
    // abzieht.
    function offerPct(cart, discount) {
      var qty = (cart && cart.item_count) || 0;
      var tier = null;
      for (var i = 0; i < offerTiers.length; i++) {
        if (qty >= offerTiers[i].qty) tier = offerTiers[i].pct;
      }
      var full = fullPrice(cart);
      if (full <= 0) return tier;
      var real = (discount / full) * 100;
      // Die gepflegte Stufe wird nur genannt, solange sie zum tatsaechlich
      // gewaehrten Rabatt passt. Liegt zusaetzlich ein Code auf dem Warenkorb
      // – etwa aus einer alten Aktion, die noch in der Sitzung des Kunden
      // steckt – stuende sonst "-15 %" neben einem Betrag von 19 %.
      if (tier !== null && Math.abs(real - tier) <= 1) return tier;
      return Math.floor(real);
    }

    // Der Warenkorb weist alle Nachlaesse zusammen in einer Zeile
    // aus: oben stehen die Listenpreise, hier steht der gesamte Nachlass. Sonst
    // muesste der Kunde zwei Rabatte gegen eine ungerabattete Zwischensumme
    // verrechnen und die Gesamtsumme ginge nicht mehr auf.
    function renderOffer(cart) {
      if (!offerEnabled || !offerRowEl) return;
      var sum = fullPrice(cart) - ((cart && cart.total_price) || 0);
      if (sum <= 0) { offerRowEl.hidden = true; stopTimer(); return; }
      offerRowEl.hidden = false;
      if (offerAmountEl) offerAmountEl.innerHTML = money(sum);
      if (offerLabelEl) {
        var pct = offerPct(cart, sum);
        offerLabelEl.textContent = offerLabelTpl.replace(
          /\{\{\s*pct\s*\}\}|\[pct\]/i,
          pct === null ? '' : String(pct).replace('.', ',')
        );
      }
      startTimer();
    }

    // Countdown bis zur lokalen Mitternacht. Er rechnet die Restzeit bei jedem
    // Tick neu aus der Uhr, statt herunterzuzaehlen – so laeuft er nach einem
    // Standby oder Tabwechsel nicht falsch und beginnt um 00:00 von selbst neu.
    var timerId = null;
    function tickTimer() {
      if (!offerTimerEl) return;
      var now = new Date();
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var left = Math.max(0, Math.floor((midnight - now) / 1000));
      var h = Math.floor(left / 3600);
      var m = Math.floor((left % 3600) / 60);
      var sec = left % 60;
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      offerTimerEl.textContent = (offerTimerPrefix ? offerTimerPrefix + ' ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
      offerTimerEl.hidden = false;
    }
    function startTimer() {
      if (!offerTimerOn || !offerTimerEl || timerId) return;
      tickTimer();
      timerId = setInterval(tickTimer, 1000);
    }
    function stopTimer() {
      if (timerId) { clearInterval(timerId); timerId = null; }
      if (offerTimerEl) offerTimerEl.hidden = true;
    }

    // ---- Angebotsleiste am Seitenanfang ----
    // Das Markup liegt in dieser Section, weil der Drawer auf jeder Seite
    // eingebunden ist; hier wandert es an den Anfang des Body.
    var topBar = document.querySelector('[data-offer-topbar]');
    if (topBar && topBar.parentNode !== document.body) {
      document.body.insertBefore(topBar, document.body.firstChild);
    }
    var topTextEl = topBar && topBar.querySelector('[data-offer-topbar-text]');
    var topTimerEl = topBar && topBar.querySelector('[data-offer-topbar-timer]');
    var topMin = topBar ? parseInt(topBar.getAttribute('data-min'), 10) || 0 : 0;
    var topLabel = topBar ? topBar.getAttribute('data-label') || '' : '';
    var topHint = topBar ? topBar.getAttribute('data-hint') || '' : '';
    var topTimerOn = topBar ? topBar.getAttribute('data-timer') === 'true' : false;
    var topTimerId = null;

    function pad2(n) { return n < 10 ? '0' + n : String(n); }
    function tickTopTimer() {
      if (!topTimerEl) return;
      var now = new Date();
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var left = Math.max(0, Math.floor((midnight - now) / 1000));
      topTimerEl.textContent = pad2(Math.floor(left / 3600)) + ':' +
        pad2(Math.floor((left % 3600) / 60)) + ':' + pad2(left % 60);
      topTimerEl.hidden = false;
    }
    function startTopTimer() {
      if (!topTimerOn || !topTimerEl || topTimerId) return;
      tickTopTimer();
      topTimerId = setInterval(tickTopTimer, 1000);
    }
    function stopTopTimer() {
      if (topTimerId) { clearInterval(topTimerId); topTimerId = null; }
      if (topTimerEl) topTimerEl.hidden = true;
    }

    // ---- Reservierungs-Countdown ----
    // Zaehlt von X Minuten auf 00:00 und haelt dort an. Die Deadline liegt in
    // sessionStorage, damit der Timer beim erneuten Oeffnen des Drawers weiter-
    // laeuft statt neu zu starten; bei leerem Warenkorb wird sie geloescht, damit
    // ein neuer Warenkorb wieder volle Zeit bekommt. Restzeit wird bei jedem Tick
    // aus der Deadline gerechnet (standby-/tabwechsel-fest).
    var reserveMin = reserveEl ? parseFloat(reserveEl.getAttribute('data-reserve-min')) || 0 : 0;
    var reserveTpl = reserveEl ? (reserveEl.getAttribute('data-reserve-text') || '') : '';
    var reserveTimeEl = null;
    var reserveId = null;
    var RESERVE_KEY = 'fnCartReserveUntil';

    function reserveDeadline(create) {
      var v = null;
      try { v = sessionStorage.getItem(RESERVE_KEY); } catch (e) {}
      var ts = v ? parseInt(v, 10) : 0;
      if ((!ts || isNaN(ts)) && create) {
        ts = new Date().getTime() + Math.round(reserveMin * 60000);
        try { sessionStorage.setItem(RESERVE_KEY, String(ts)); } catch (e) {}
      }
      return ts || 0;
    }
    function clearReserveDeadline() {
      try { sessionStorage.removeItem(RESERVE_KEY); } catch (e) {}
    }
    function buildReserveMsg() {
      if (!reserveEl || reserveTimeEl) return;
      var msg = reserveEl.querySelector('[data-reserve-msg]');
      if (!msg) return;
      var parts = reserveTpl.split('[time]');
      msg.textContent = '';
      msg.appendChild(document.createTextNode(parts[0] || ''));
      reserveTimeEl = document.createElement('span');
      reserveTimeEl.className = 'fn-cart-drawer__reserve-time';
      reserveTimeEl.setAttribute('data-reserve-timer', '');
      msg.appendChild(reserveTimeEl);
      msg.appendChild(document.createTextNode(parts.length > 1 ? parts.slice(1).join('[time]') : ''));
    }
    function tickReserve() {
      if (!reserveTimeEl) return;
      var ts = reserveDeadline(false);
      var left = ts ? Math.floor((ts - new Date().getTime()) / 1000) : 0;
      if (left <= 0) {
        // Abgelaufen -> der Timer beginnt sofort wieder von vorn (neue Frist).
        ts = new Date().getTime() + Math.round(reserveMin * 60000);
        try { sessionStorage.setItem(RESERVE_KEY, String(ts)); } catch (e) {}
        left = Math.round(reserveMin * 60);
      }
      var m = Math.floor(left / 60);
      var s = left % 60;
      reserveTimeEl.textContent = m + ':' + (s < 10 ? '0' + s : String(s));
    }
    function startReserve() {
      if (!reserveEl || reserveMin <= 0) return;
      buildReserveMsg();
      reserveDeadline(true); // Deadline anlegen, falls noch keine
      reserveEl.hidden = false;
      tickReserve();
      if (!reserveId) reserveId = setInterval(tickReserve, 1000);
    }
    function stopReserve() {
      if (reserveId) { clearInterval(reserveId); reserveId = null; }
      if (reserveEl) reserveEl.hidden = true;
    }
    // Bei jeder Mengenaenderung beginnt die Reservierungsfrist von vorn.
    function restartReserve() {
      if (!reserveEl || reserveMin <= 0) return;
      clearReserveDeadline();
      reserveDeadline(true);
      if (reserveTimeEl) tickReserve();
    }

    // ---- Lagerbestand-Check ----
    // Spielt einmal pro Session die Pruef-Animation (Balken + Zahnrad),
    // kippt in „auf Lager!" und blendet danach den Reservierungs-Timer ein.
    // render() laeuft bei jeder Warenkorb-Aenderung erneut, deshalb haelt
    // stockState fest, ob die Animation fuer dieses Oeffnen schon lief.
    var stockEl = root.querySelector('[data-cart-stockcheck]');
    var stockState = 'idle'; // idle | running | done (pro Oeffnen)
    var stockTimers = [];
    // Die Pruef-Animation laeuft nur einmal pro Session; danach (und auch wenn
    // der Timer schon einmal abgelaufen war) erscheint sofort der fertige
    // gruene Zustand ohne erneutes "Pruefen".
    var STOCK_KEY = 'fnCartStockChecked';
    function stockChecked() {
      try { return sessionStorage.getItem(STOCK_KEY) === '1'; } catch (e) { return false; }
    }
    function markStockChecked() {
      try { sessionStorage.setItem(STOCK_KEY, '1'); } catch (e) {}
    }
    function showStockDone() {
      if (!stockEl) return;
      stockTimers.forEach(clearTimeout);
      stockTimers = [];
      var fill = stockEl.querySelector('[data-stockcheck-fill]');
      var badge = stockEl.querySelector('[data-stockcheck-badge]');
      var label = stockEl.querySelector('[data-stockcheck-label]');
      if (fill) { fill.style.transition = 'none'; fill.style.width = '100%'; }
      if (badge) { badge.style.transition = 'none'; badge.style.left = '100%'; }
      if (label) label.textContent = stockEl.getAttribute('data-done-text') || '';
      stockEl.classList.add('is-done');
      stockEl.classList.add('has-timer');
      stockEl.hidden = false;
      stockState = 'done';
    }
    function resetStockCheck() {
      stockTimers.forEach(clearTimeout);
      stockTimers = [];
      stockState = 'idle';
      if (stockEl) {
        stockEl.hidden = true;
        stockEl.classList.remove('is-done');
        stockEl.classList.remove('has-timer');
      }
    }
    function startScarcity() {
      if (!stockEl || stockState === 'done') { startReserve(); return; }
      if (stockState === 'running') return; // Abschluss startet den Timer selbst
      if (stockChecked()) { showStockDone(); startReserve(); return; }
      // render() laeuft auch bei geschlossenem Drawer (Seitenladung, Add-to-Cart
      // im Hintergrund). Die einmalige Animation soll aber erst beim ersten
      // echten Oeffnen sichtbar ablaufen — sonst waere sie schon "verbraucht".
      if (!root.classList.contains('is-open')) return;
      stockState = 'running';
      if (reserveEl) reserveEl.hidden = true;
      var fill = stockEl.querySelector('[data-stockcheck-fill]');
      var badge = stockEl.querySelector('[data-stockcheck-badge]');
      var label = stockEl.querySelector('[data-stockcheck-label]');
      var dur = (parseFloat(stockEl.getAttribute('data-check-seconds')) || 2) * 1000;
      try { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) dur = 0; } catch (e) {}
      stockEl.classList.remove('is-done');
      if (label) label.textContent = stockEl.getAttribute('data-check-text') || '';
      // Startzustand ohne Uebergang setzen, erst im uebernaechsten Frame
      // animieren – sonst springt der Balken direkt auf 100 %.
      if (fill) { fill.style.transition = 'none'; fill.style.width = '0%'; }
      if (badge) { badge.style.transition = 'none'; badge.style.left = '0%'; }
      stockEl.hidden = false;
      if (fill) void fill.offsetWidth; // Startzustand ins Layout zwingen (Reflow)
      // Zwei Schritte: erst bis 1/3 („wird geprueft…", Zahnrad dreht in der
      // Denkpause weiter), dann volles Banner („auf Lager!"). Die Gesamtdauer
      // aus dem Editor wird auf Anlauf/Pause/Endspurt verteilt.
      var t1 = Math.round(dur * 0.3), hold = Math.round(dur * 0.55), t2 = Math.round(dur * 0.15);
      var ease = 'ms cubic-bezier(0.3, 0.6, 0.3, 1)';
      stockTimers.push(setTimeout(function () {
        if (fill) { fill.style.transition = 'width ' + t1 + ease; fill.style.width = '33.3%'; }
        if (badge) { badge.style.transition = 'left ' + t1 + ease; badge.style.left = '33.3%'; }
      }, 30));
      stockTimers.push(setTimeout(function () {
        if (fill) { fill.style.transition = 'width ' + t2 + ease; fill.style.width = '100%'; }
        if (badge) { badge.style.transition = 'left ' + t2 + ease; badge.style.left = '100%'; }
      }, 30 + t1 + hold));
      stockTimers.push(setTimeout(function () {
        stockEl.classList.add('is-done');
        if (label) label.textContent = stockEl.getAttribute('data-done-text') || '';
      }, 30 + t1 + hold + t2 + 60));
      // Banner bleibt stehen; der Timer dockt platzsparend darunter an.
      stockTimers.push(setTimeout(function () {
        stockEl.classList.add('has-timer');
        stockState = 'done';
        markStockChecked(); // ab jetzt fuer den Rest der Session nur noch der fertige Zustand
        startReserve();
      }, 30 + t1 + hold + t2 + 660));
    }

    // Auf der Produktseite zaehlt das gerade gewaehlte Paket, sonst nur der
    // Warenkorb – so ist die Leiste schon aktiv, bevor etwas hinzugefuegt wurde.
    function selectedPackQty() {
      var card = document.querySelector('[data-variant-wrap] [data-variant-card][aria-checked="true"]');
      var wrap = card && card.closest('[data-variant-wrap]');
      return wrap ? parseInt(wrap.getAttribute('data-variant-qty'), 10) || 0 : 0;
    }

    function renderTopBar(cart) {
      if (!topBar) return;
      var count = Math.max(cart ? cart.item_count || 0 : 0, selectedPackQty());
      var active = topMin > 0 && count >= topMin;
      var text = active ? topLabel : topHint;
      if (!text) { topBar.hidden = true; stopTopTimer(); return; }
      topBar.hidden = false;
      topBar.classList.toggle('fn-offer-bar--hint', !active);
      if (topTextEl) topTextEl.textContent = text;
      if (active) startTopTimer();
      else stopTopTimer();
    }

    // Paketwechsel auf der Produktseite sofort spiegeln.
    if (topBar) {
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-variant-card]')) {
          setTimeout(function () { renderTopBar(lastCart); }, 0);
        }
      });
      renderTopBar(null);
    }

    // Versandzeile plus Gesamtsumme. Gratis-Versand folgt in Italien der Menge
    // (die Versandrate "Spedizione gratuita" im Admin ist gewichtsbasiert, ab
    // 2 Packungen), nicht dem Preis. Ist shipFreeQty 0, gilt die Preisgrenze.
    function shipIsFree(cart) {
      var total = (cart && cart.total_price) || 0;
      var qty = (cart && cart.item_count) || 0;
      if (shipFreeQty > 0) return qty >= shipFreeQty;
      return fsThreshold > 0 && total >= fsThreshold;
    }
    function renderSums(cart) {
      var total = (cart && cart.total_price) || 0;
      var free = shipIsFree(cart);
      var ship = free ? 0 : shippingCost;
      if (shippingEl) {
        shippingEl.innerHTML = free || ship === 0
          ? '<span class="fn-cart-drawer__shipping-free">' + esc(shipFreeText) + '</span>'
          : money(ship);
      }
      if (shipNoteEl) shipNoteEl.hidden = !(free && total > 0);
      if (grandTotalEl) grandTotalEl.innerHTML = money(total + ship);
    }

    // Upsell-Hinweis: nur bei genau der Startmenge (1 Packung). Der Text ist
    // ein fester Editor-Text, es werden keine Preise erfunden.
    function renderUpsell(cart) {
      upsellReady = false;
      if (!upsellEl) return;
      var items = (cart && cart.items) || [];
      var qty = (cart && cart.item_count) || 0;
      if (bundleMode || items.length !== 1 || qty !== upsellFrom || upsellTo <= upsellFrom) {
        hideUpsell();
        return;
      }
      upsellReady = true;
      if (!upsellStepEl) upsellEl.hidden = false;
    }

    function hideUpsell() {
      upsellReady = false;
      if (upsellEl) upsellEl.hidden = true;
    }

    // Platzhalter in den Editor-Texten ersetzen; **fett** bleibt wie in den
    // Versandtexten erlaubt. Bevorzugt [diff]: geschweifte Klammern stehen bis
    // zum Ersetzen im Quelltext und lesen sich fuer Crawler wie ein kaputtes
    // Liquid-Template. Die alte Schreibweise bleibt der Vollstaendigkeit halber.
    function fill(tpl, vals) {
      return bold(esc(tpl)).replace(/\{\{\s*(\w+)\s*\}\}|\[(\w+)\]/g, function (m, k1, k2) {
        var key = k1 || k2;
        return Object.prototype.hasOwnProperty.call(vals, key) ? '<b>' + vals[key] + '</b>' : m;
      });
    }

    // Obere Zeile + Gratis-Versand-Balken. Fortschritt = Warenkorb-Menge /
    // shipping_free_from_qty (gleiche Regel wie shipIsFree), also 1 von 2 = 50 %.
    function renderTop(cart) {
      var qty = (cart && cart.item_count) || 0;
      if (topEl) topEl.hidden = qty <= 0;
      if (!sbEl) return;
      if (qty <= 0 || shipFreeQty <= 0) { sbEl.hidden = true; return; }
      var done = qty >= shipFreeQty;
      var pct = Math.min(100, Math.round((qty / shipFreeQty) * 100));
      sbEl.hidden = false;
      sbEl.classList.toggle('is-done', done);
      if (sbFill) sbFill.style.width = pct + '%';
      if (sbTrack) sbTrack.setAttribute('aria-valuenow', String(pct));
      if (sbText) {
        sbText.innerHTML = done
          ? bold(esc(sbEl.getAttribute('data-sb-done') || ''))
          : fill(sbEl.getAttribute('data-sb-before') || '', { n: shipFreeQty - qty });
      }
    }

    function renderShipping(total) {
      if (!fsEnabled || !fsWrap || fsThreshold <= 0) { if (fsWrap) fsWrap.hidden = true; return; }
      fsWrap.hidden = false;
      // Gemessen wird am Warenwert (Zwischensumme), NICHT an der Endsumme inkl.
      // Versand – die Gratis-Versand-Freigrenze im Shop bezieht sich auf den
      // Warenwert. Sonst zeigt der leere Warenkorb 75,01 statt der echten 80.
      var pct = Math.min(100, Math.round((total / fsThreshold) * 100));
      if (fsFill) fsFill.style.width = pct + '%';
      if (total >= fsThreshold) {
        fsLabel.innerHTML = bold(esc(fsSuccessTpl));
      } else {
        var gap = fsThreshold - total;
        var remaining = '<b>' + money(gap) + '</b>';
        // The amount placeholder in the setting is replaced with the remaining sum.
        fsLabel.innerHTML = bold(esc(fsProgressTpl)).replace(/\{\{\s*amount\s*\}\}|\[amount\]/i, remaining);
      }
    }

    // *stars* in the shipping labels become bold, so merchants can emphasise the
    // opening words ("**Perfekt!** Wir schenken dir den Versand.") from the editor.
    function bold(s) {
      return s.replace(/\*\*(.+?)\*\*/g, '<b>$1</b>');
    }

    // Anzeige-Aufteilung einer Warenkorbzeile (Shopify haelt EINE Zeile mit
    // Menge 3). Aus dem echten Rabatt abgeleitet: wie viele Packungen hat
    // Shopify wirklich gratis gerechnet? Nur wenn mindestens so viele Gratis-
    // Packungen abgezogen sind, wie die Regel (je freeAt eine) verspricht, wird
    // die Zeile als "2 bezahlt + 1 gratis" gezeigt. Sonst bleibt es eine
    // normale Zeile – die Anzeige verspricht nie mehr als der Checkout rechnet.
    function v2Split(item) {
      var qty = item.quantity;
      var rule = packCounter ? capFree(Math.floor(qty / freeAt)) : 0;
      var applied = item.original_price > 0
        ? Math.round(((item.original_line_price || 0) - (item.final_line_price || 0)) / item.original_price)
        : 0;
      if (rule > 0 && applied < rule) return { counter: false, paid: qty, free: 0 };
      return { counter: packCounter, paid: qty - rule, free: rule };
    }
    function v2ItemHtml(item, line, img, subHtml) {
      var sp = v2Split(item);
      var name = esc(item.product_title);
      var thumbHtml = function (src) {
        return '<span class="fn-v2-thumb">' + (src ? '<img src="' + src + '" alt="' + name + '" width="84" height="84" loading="lazy">' : '') + '</span>';
      };
      var attrs = ' data-line="' + line + '" data-quantity="' + item.quantity + '"';
      var unit = money(item.original_price) + (unitText ? ' ' + esc(unitText) : '');
      var minusOff = sp.counter ? sp.paid <= 1 : item.quantity <= 1;
      var html = '<li class="fn-cart-drawer__item fn-v2-line"' + attrs + '>' +
        thumbHtml(img) +
        '<div class="fn-v2-info">' +
          '<a class="fn-v2-t" href="' + esc(item.url) + '">' + name + '</a>' +
          subHtml +
          '<div class="fn-v2-tot">' + money(item.final_line_price) + '</div>' +
          '<div class="fn-v2-u">' + unit + '</div>' +
        '</div>' +
        '<div class="fn-v2-side">' +
          '<div class="fn-v2-qty" role="group" aria-label="' + esc(tQty) + '">' +
            '<button type="button" data-qty-down aria-label="Diminuisci quantità"' + (minusOff ? ' disabled' : '') + '>−</button>' +
            '<span data-qty>' + sp.paid + '</span>' +
            '<button type="button" data-qty-up aria-label="Aumenta quantità">+</button>' +
          '</div>' +
          (hideRemove ? '' : '<button type="button" class="fn-v2-rm" data-remove>' + esc(tRemove) + '</button>') +
        '</div>' +
      '</li>';
      if (sp.free > 0) {
        var freeImg = freeImage ? esc(freeImage) : img;
        html += '<li class="fn-cart-drawer__item fn-cart-drawer__free fn-v2-line fn-v2-line--free"' + attrs + '>' +
          thumbHtml(freeImg) +
          '<div class="fn-v2-info">' +
            '<span class="fn-v2-t">' + name + '</span>' +
            subHtml +
            (freeActive ? '<div class="fn-v2-inc">' + esc(freeActive) + '</div>' : '') +
          '</div>' +
          '<div class="fn-v2-side">' +
            '<div class="fn-v2-qty fn-v2-qty--fixed">' + esc(tQty) + ' ' + sp.free + '</div>' +
            '<div class="fn-v2-price">' +
              '<span class="fn-v2-old">' + money(item.original_price * sp.free) + '</span>' +
              '<span class="fn-v2-p">' + money(0) + '</span><br>' +
              '<span class="fn-v2-gratis">' + esc(tGratis) + '</span>' +
            '</div>' +
          '</div>' +
        '</li>';
      }
      return html;
    }

    // Paket-Karte: Name des Pakets, echter Zeilenpreis, Statt-Preis
    // durchgestrichen, die Ersparnis als Pille und darunter die Haekchen.
    // [gusto] in einem Haekchen wird zur Geschmacksrichtung der Zeile.
    var tickSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5l5 5L20 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    function saveLabel(was, now, text) {
      if (!text || was <= now) return '';
      var pct = Math.round((was - now) / was * 100);
      return esc(text).replace(/\[amount\]/g, money(was - now)).replace(/\[percent\]/g, pct + '%');
    }
    function bundleItemHtml(item, line, img, subHtml) {
      // Paketzahl: groesstes Paket, das die Menge glatt teilt (6 = 2 × 3er, 2 = 2 × 1er).
      var b = bundles.slice().sort(function (x, y) { return y.qty - x.qty; })
        .filter(function (x) { return x.qty > 0 && item.quantity % x.qty === 0; })[0];
      var n = b ? item.quantity / b.qty : 1;
      var name = esc(item.product_title);
      var now = item.final_line_price;
      var was = Math.max(item.original_line_price || 0, b ? b.compare * n : 0);
      if (item.quantity > 1 && packImage) img = esc(packImage);
      var save = saveLabel(was, now, item.quantity === 1 && bundleSaveSingle ? bundleSaveSingle : bundleSaveText);
      // „1 confezione gratis“ bei 2 × 3er-Paket = „2 confezioni gratis“.
      if (save && n > 1) save = save.replace(/^(\d+)(\s+)(\S+)/, function (m, d, sp, w) {
        return (parseInt(d, 10) * n) + sp + (w === 'confezione' ? 'confezioni' : w);
      });
      var flavour = item.product_has_only_default_variant === false && item.variant_title ? item.variant_title : '';
      var ticks = (b ? b.ticks : []).map(function (t) {
        if (t.indexOf('[gusto]') > -1) {
          if (!flavour) return '';
          var fl = t.indexOf('[gusto]') > 0 ? flavour.charAt(0).toLowerCase() + flavour.slice(1) : flavour;
          t = t.replace(/\[gusto\]/g, fl);
        } else if (n > 1) {
          // Mengen-Haekchen mitzaehlen: „3 confezioni · 90 sere“ × 2 = „6 confezioni · 180 sere“.
          t = t.replace(/(^|·\s*)(\d+)(\s+)(\S+)/g, function (m, pre, d, sp, w) {
            return pre + (parseInt(d, 10) * n) + sp + (w === 'confezione' ? 'confezioni' : w);
          });
        }
        return '<li class="fn-bx-tick">' + tickSvg + esc(t) + '</li>';
      }).join('');
      var hasFlavourTick = b && b.ticks.some(function (t) { return t.indexOf('[gusto]') > -1; });
      return '<li class="fn-cart-drawer__item fn-v2-line fn-bx" data-line="' + line + '" data-quantity="' + item.quantity + '">' +
        '<div class="fn-bx-main">' +
          '<span class="fn-v2-thumb">' + (img ? '<img src="' + img + '" alt="' + name + '" width="84" height="84" loading="lazy">' : '') + '</span>' +
          '<div class="fn-v2-info">' +
            '<span class="fn-bx-name">' + (b ? (n > 1 ? n + ' × ' : '') + esc(b.name) : name) + '</span>' +
            '<span class="fn-cart-drawer__variant">' + name + '</span>' +
            (hasFlavourTick ? '' : subHtml) +
            (save ? '<span class="fn-bx-save">' + save + '</span>' : '') +
          '</div>' +
          '<div class="fn-bx-ctrl">' +
          (b ? '<div class="fn-v2-qty" role="group" aria-label="' + esc(tQty) + '">' +
            '<button type="button" data-pack-qty="' + (item.quantity - b.qty) + '" aria-label="Un pacchetto in meno"' + (n <= 1 ? ' disabled' : '') + '>−</button>' +
            '<span data-qty>' + n + '</span>' +
            '<button type="button" data-pack-qty="' + (item.quantity + b.qty) + '" aria-label="Un pacchetto in più">+</button>' +
          '</div>' : '') +
          (hideRemove ? '' : '<button type="button" class="fn-v2-rm" data-remove>' + esc(tRemove) + '</button>') +
          '</div>' +
          // Zeile unter dem Bild: Verknappung links, Preis rechts auf einer Linie.
          '<span class="fn-bx-scarcity">' + esc(bundleScarcity) + '</span>' +
          '<div class="fn-bx-price">' +
            (was > now ? '<span class="fn-v2-old">' + money(was) + '</span>' : '') +
            '<span class="fn-bx-now">' + money(now) + '</span>' +
          '</div>' +
        '</div>' +
        (ticks ? '<ul class="fn-bx-ticks" role="list">' + ticks + '</ul>' : '') +
      '</li>';
    }

    // Eine Menge, die nicht zum Schema passt (z. B. 2 oder 5), wird einmal auf
    // die naechste passende gesetzt: 2 → 2 bezahlt + 1 gratis = 3.
    function normaliseCounter(cart) {
      if (!packCounter || !cart || !cart.items) return;
      cart.items.some(function (it, i) {
        if (!v2Split(it).counter) return false;
        var want = cartQty(paidOf(it.quantity));
        var key = (i + 1) + ':' + it.quantity;
        if (want === it.quantity || normalisedQty[key]) return false;
        normalisedQty[key] = true;
        changeLine(i + 1, want);
        return true;
      });
    }

    // Ein „Kauf X, erhalte Y“-Rabatt teilt dieselbe Variante in Shopify in
    // mehrere Zeilen (bezahlt / gratis). Fuer die Anzeige und den Zaehler werden
    // sie wieder zu einer Zeile zusammengefasst; _keys merkt sich die echten Zeilen.
    function mergeLines(cart) {
      if (!cart || !cart.items || cart.items.length < 2) return cart;
      var out = [], byId = {};
      cart.items.forEach(function (it) {
        var id = it.variant_id + '|' + JSON.stringify(it.properties || {}) + '|' + ((it.selling_plan_allocation && it.selling_plan_allocation.selling_plan.id) || '');
        var m = byId[id];
        if (!m) {
          m = byId[id] = Object.assign({}, it, {
            _keys: it._keys ? it._keys.slice() : [{ key: it.key, quantity: it.quantity }],
            discounts: (it.discounts || []).slice(),
            line_level_discount_allocations: (it.line_level_discount_allocations || []).slice()
          });
          out.push(m);
          return;
        }
        m.quantity += it.quantity;
        ['line_price', 'original_line_price', 'final_line_price', 'total_discount', 'line_level_total_discount'].forEach(function (f) {
          m[f] = (m[f] || 0) + (it[f] || 0);
        });
        m._keys.push({ key: it.key, quantity: it.quantity });
        (it.discounts || []).forEach(function (d) {
          var hit = m.discounts.filter(function (x) { return x.title === d.title; })[0];
          if (hit) hit.amount = (hit.amount || 0) + (d.amount || 0); else m.discounts.push(Object.assign({}, d));
        });
        m.line_level_discount_allocations = m.line_level_discount_allocations.concat(it.line_level_discount_allocations || []);
      });
      out.forEach(function (m) {
        if (m.quantity) m.final_price = Math.round(m.final_line_price / m.quantity);
      });
      return Object.assign({}, cart, { items: out });
    }

    function render(cart) {
      if (!cart) return;
      cart = mergeLines(cart);
      lastCart = cart;
      setCounts(cart.item_count);
      renderShipping(cart.total_price);
      renderSums(cart);
      renderOffer(cart);
      renderUpsell(cart);
      renderTopBar(cart);
      renderTop(cart);

      if (!cart.items || !cart.items.length) {
        itemsEl.innerHTML = '';
        if (cardEl) cardEl.hidden = true;
        if (reviewEl) reviewEl.hidden = true;
        emptyEl.hidden = false;
        footEl.hidden = true;
        stopReserve();
        resetStockCheck(); // leerer Warenkorb → Check beim naechsten Mal neu
        clearReserveDeadline(); // leerer Warenkorb → neuer Timer beim naechsten Mal
        return;
      }
      emptyEl.hidden = true;
      if (cardEl) cardEl.hidden = false;
      if (reviewEl) reviewEl.hidden = false;
      footEl.hidden = false;
      startScarcity();
      // Zwischensumme = tatsaechlicher Warenkorbwert nach Shopify-Rabatt. Nur wenn
      // Shopify wirklich einen Nachlass rechnet, steht die Listensumme
      // durchgestrichen davor (z. B. 119,70 -> 79,80). Kein erfundener Statt-Preis.
      var listTotal = fullPrice(cart);
      subtotalEl.innerHTML = money(cart.total_price);
      if (subtotalWasEl) {
        var showWas = listTotal > cart.total_price;
        subtotalWasEl.innerHTML = showWas ? money(listTotal) : '';
        subtotalWasEl.hidden = !showWas;
      }
      if (totalsEl) totalsEl.classList.add('is-full');

      itemsEl.innerHTML = cart.items.map(function (item, i) {
        var line = i + 1;
        var img = item.image ? esc(thumbUrl(item.image)) : (item.featured_image && item.featured_image.url ? esc(thumbUrl(item.featured_image.url)) : '');
        var sub = [];
        if (item.product_has_only_default_variant === false && item.variant_title) sub.push(esc(item.variant_title));
        if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
          sub.push(esc(item.selling_plan_allocation.selling_plan.name));
        }
        var subHtml = sub.length ? '<span class="fn-cart-drawer__variant">' + sub.join(' · ') + '</span>' : '';
        if (bundleMode) return bundleItemHtml(item, line, img, subHtml);
        if (!legacyButtons) return v2ItemHtml(item, line, img, subHtml);
        // Beim Bundle (z. B. 2+1) zeigt das Vorschaubild alle Packungen.
        var isBundle = packOptions.some(function (o) { return o.qty > 1 && o.qty === item.quantity; });
        if (isBundle && packImage) img = esc(packImage);
        var thumb = img ? '<img class="fn-cart-drawer__thumb' + (isBundle && packImage ? ' fn-cart-drawer__thumb--bundle' : '') + '" src="' + img + '" alt="' + esc(item.product_title) + '" width="84" height="84" loading="lazy">' : '<span class="fn-cart-drawer__thumb"></span>';

        // Bei Mengenrabatt (2er/3er) steht der neue Paketpreis vorne, der
        // Listenpreis daneben durchgestrichen. Der neue Preis wird aus dem
        // wirklich gewaehrten Rabatt abgeleitet (Listenpreis anteilig auf die
        // rabattierte Warenkorbsumme skaliert), nicht aus einem geschaetzten
        // Prozentsatz – so trifft die Zeile den Betrag im Checkout auf den Cent
        // und passt zur Gesamtsumme unten. Beim 1er greift kein Rabatt: dann
        // steht wie bisher nur der Listenpreis da.
        var lineFull = fullPrice(cart);
        var lineDisc = lineFull - ((cart && cart.total_price) || 0);
        var lineNow = lineDisc > 0 && lineFull > 0
          ? Math.round(item.original_line_price * ((cart.total_price) / lineFull))
          : item.original_line_price;
        var lineWas = item.original_line_price;
        var priceHtml = '<div class="fn-cart-drawer__prices">' +
          (lineNow < lineWas
            ? '<span class="fn-cart-drawer__now">' + money(lineNow) + '</span>' +
              '<span class="fn-cart-drawer__was">' + money(lineWas) + '</span>'
            : '<span class="fn-cart-drawer__now">' + money(item.original_line_price) + '</span>') +
          '</div>';

        // Preis pro Nacht: der Zeilenpreis (nach Rabatt) geteilt durch alle
        // Naechte der Zeile – Menge x Portionen je Packung.
        var nightHtml = '';
        if (nightText && nightServings > 0 && item.quantity > 0) {
          var nightBase = nightPrices[item.quantity] || lineNow;
          var perNight = money(Math.round(nightBase / (item.quantity * nightServings)));
          nightHtml = '<span class="fn-cart-drawer__per-night">' + esc(nightText).replace(/\[price\]/g, '<b>' + perNight + '</b>') + '</span>';
        }
        nightHtml = packHtmlFor(nightPrices[item.quantity] || lineNow, item.quantity) + nightHtml;

        // Shopify only sends unit_price for products that declare a unit measure.
        // Off by default: next to a pack price the per-kg figure reads as a
        // second, contradictory price.
        var unitHtml = '';
        if (showUnitPrice && item.unit_price && item.unit_price_measurement) {
          var m = item.unit_price_measurement;
          var ref = (m.reference_value && m.reference_value !== 1 ? m.reference_value : '') + (m.reference_unit || '');
          unitHtml = '<span class="fn-cart-drawer__unit">(' + money(item.unit_price) + (ref ? '/' + esc(ref) : '') + ')</span>';
        }

        // Pakete statt +/-: nur die gepflegten Mengen sind waehlbar.
        var packHtml = '';
        var chipHtml = '';
        if (packOptions.length) {
          var activePack = null;
          packHtml = '<div class="fn-cart-drawer__packs" role="group" aria-label="Pacchetto">' +
            packOptions.map(function (o) {
              var on = o.qty === item.quantity;
              if (on) activePack = o;
              return '<button type="button" data-pack-qty="' + o.qty + '" aria-pressed="' + on + '"' +
                (on ? ' class="is-active"' : '') + '>' + esc(o.label) + '</button>';
            }).join('') +
            '</div>';
          if (activePack && activePack.qty > 1) {
            chipHtml = '<span class="fn-cart-drawer__pack-chip">' + esc(packChip || activePack.label) + '</span>' +
              (packNote ? '<span class="fn-cart-drawer__variant">' + esc(packNote.replace(/\[qty\]/g, item.quantity)) + '</span>' : '');
          }
        }
        var qtyHtml = packOptions.length ? '' :
          '<div class="fn-cart-drawer__qty">' +
            '<button type="button" data-qty-down aria-label="Diminuisci quantità"' + (item.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
            '<span data-qty>' + item.quantity + '</span>' +
            '<button type="button" data-qty-up aria-label="Aumenta quantità">+</button>' +
          '</div>';

        return '' +
          '<li class="fn-cart-drawer__item' + (packOptions.length ? ' has-packs' : '') + '" data-line="' + line + '" data-quantity="' + item.quantity + '">' +
            thumb +
            '<div class="fn-cart-drawer__info">' +
              '<a class="fn-cart-drawer__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
              chipHtml +
              priceHtml +
              nightHtml +
              unitHtml +
              subHtml +
            '</div>' +
            '<div class="fn-cart-drawer__side">' +
              qtyHtml +
              (hideRemove ? '' : '<button type="button" class="fn-cart-drawer__remove" data-remove>Rimuovi</button>') +
            '</div>' +
            packHtml +
          '</li>';
      }).join('');
      normaliseCounter(cart);
    }

    var lastCart = null;
    // Der laufende Warenkorb-Abruf. Der Checkout-Klick wartet darauf, damit der
    // Zwischenschritt nicht verschluckt wird, wenn jemand sofort klickt.
    var pendingRefresh = null;
    function refresh() {
      root.classList.add('is-loading');
      pendingRefresh = fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(ensureOfferCode)
        .then(function (cart) { lastCart = cart; render(cart); })
        .finally(function () { root.classList.remove('is-loading'); });
      return pendingRefresh;
    }

    // Meta-AddToCart-Wert (snippets/fl-atc-value): Der Wrapper braucht Variante, alte und neue
    // Menge sowie die Gratis-Regel. Summe je Variante, weil Shopify 2+1 in bezahlt/gratis aufteilt.
    function flQtyOf(cart, vid) {
      var n = 0;
      ((cart && cart.items) || []).forEach(function (it) { if (String(it.variant_id) === String(vid)) n += it.quantity || 0; });
      return n;
    }
    function flAtcMark(vid, oldQty, newQty) {
      try {
        var it = ((lastCart && lastCart.items) || []).filter(function (x) { return String(x.variant_id) === String(vid); })[0];
        window.flAtc = {
          t: Date.now(), variantId: String(vid), oldQty: oldQty, newQty: newQty,
          unit: it && it.original_price > 0 ? it.original_price / 100 : 0,
          currency: (lastCart && lastCart.currency) || '',
          freeAt: packCounter ? freeAt : 0, freeMax: packCounter ? freeMax : 0, src: 'drawer'
        };
      } catch (e) {}
    }

    function changeLine(line, quantity) {
      root.classList.add('is-loading');
      var merged = lastCart && lastCart.items && lastCart.items[line - 1];
      if (merged && quantity > 0) flAtcMark(merged.variant_id, flQtyOf(lastCart, merged.variant_id), quantity);
      var keys = merged && merged._keys;
      var req;
      if (keys && keys.length > 1) {
        var updates = {};
        keys.forEach(function (k, i) { updates[k.key] = i === 0 ? quantity : 0; });
        req = { url: '/cart/update.js', body: { updates: updates } };
      } else {
        req = { url: '/cart/change.js', body: { line: line, quantity: quantity } };
      }
      return fetch(req.url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(req.body)
      })
        .then(function (r) { return r.json(); })
        .then(ensureOfferCode)
        .then(function (cart) {
          lastCart = cart;
          render(cart);
          // Mengenaenderung -> Reservierungsfrist beginnt von vorn (nur wenn noch
          // etwas im Warenkorb ist; beim Leeren uebernimmt render das Stoppen).
          if (cart && cart.item_count > 0) restartReserve();
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .finally(function () { root.classList.remove('is-loading'); });
    }

    // ---- open / close ----
    var pageMode = root.getAttribute('data-page-mode') === 'true';
    function open(skipRefresh) {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('fn-cart-locked');
      if (stockChecked()) {
        showStockDone(); // schon geprueft → fertiger Zustand, keine neue Animation
      } else {
        resetStockCheck(); // erste Pruefung dieser Session laeuft animiert
        if (stockEl && reserveEl) reserveEl.hidden = true; // kein Timer-Blitzer vor dem Check
      }
      if (skipRefresh !== true) refresh();
      var closeBtn = root.querySelector('.fn-cart-drawer__close');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      // Auf /cart gibt es keine Seite "hinter" dem Warenkorb: Schliessen fuehrt zur Startseite.
      if (pageMode) { window.location.href = '/'; return; }
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('fn-cart-locked');
      // Wer den Warenkorb ganz zumacht, faengt beim naechsten Oeffnen neu an:
      // sonst bliebe das Angebot nach einem einzigen Blick fuer den Rest des
      // Seitenaufrufs stumm. Pro Oeffnen wird weiterhin hoechstens einmal
      // gefragt, der Zwischenschritt startet dabei immer geschlossen.
      upsellAsked = false;
      upsellAskCount = 0;
      if (upsellStepEl) upsellStepEl.hidden = true;
    }

    // Zurueck-Taste aus der Kasse: der Browser holt die Seite aus dem Cache,
    // samt aller Merker. Ohne das hier bliebe das Angebot danach stumm.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      upsellAsked = false;
      upsellAskCount = 0;
      if (upsellStepEl) upsellStepEl.hidden = true;
    });

    // Intercept the header cart trigger (also fires for the programmatic
    // .click() that functions-product.js runs after add-to-cart).
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cart-drawer-trigger]');
      if (trigger) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-cart-close]')) { close(); return; }
      // Der Checkout-Button haelt einmal an, solange das Angebot noch steht.
      var checkoutLink = e.target.closest('.fn-cart-drawer__checkout');
      if (checkoutLink && upsellStepEl && !upsellAsked) {
        checkoutHref = checkoutLink.getAttribute('href') || '/checkout';
        if (upsellReady) {
          e.preventDefault();
          upsellAsked = true;
          upsellAskCount++;
          upsellStepEl.hidden = false;
          return;
        }
        // Der Warenkorb wird noch geladen – wer sofort klickt, hat den Schritt
        // sonst nie gesehen. Der Klick wartet kurz auf die Antwort und geht
        // spaetestens nach 1,2 s so oder so zur Kasse.
        if (pendingRefresh) {
          e.preventDefault();
          var done = false;
          var goOnToCheckout = function () {
            if (done) return;
            done = true;
            window.location.href = checkoutHref;
          };
          var fallback = setTimeout(goOnToCheckout, 1200);
          Promise.resolve(pendingRefresh)
            .catch(function () {})
            .then(function () {
              clearTimeout(fallback);
              if (done) return;
              if (upsellReady && !upsellAsked) {
                done = true;
                upsellAsked = true;
                upsellAskCount++;
                upsellStepEl.hidden = false;
                return;
              }
              goOnToCheckout();
            });
          return;
        }
      }

      // Die zweite Packung ist dieselbe Variante, also reicht das Hochsetzen der
      // Zeilenmenge – ein zweites /cart/add wuerde eine zweite Zeile anlegen.
      if (e.target.closest('[data-upsell-cta]')) {
        var goOn = !!e.target.closest('[data-upsell-continue]');
        changeLine(1, upsellTo).then(function () {
          // Im Zwischenschritt hat der Kunde die Kasse schon angesteuert, also
          // wird er dorthin durchgereicht statt zurueck in den Warenkorb.
          if (goOn) window.location.href = checkoutHref;
        });
        return;
      }
      if (e.target.closest('[data-upsell-skip]')) {
        window.location.href = checkoutHref;
        return;
      }
      // Das X schliesst nur den Zwischenschritt und laesst den Kunden im
      // Warenkorb. Gefragt wird trotzdem nicht noch einmal – upsellAsked steht
      // bereits, sonst haenge der naechste Klick auf "Zur Kasse" wieder fest.
      if (e.target.closest('[data-upsell-dismiss]')) {
        dismissUpsellStep();
        return;
      }

      var item = e.target.closest('.fn-cart-drawer__item');
      if (!item || !root.contains(item)) return;
      var line = parseInt(item.getAttribute('data-line'), 10);
      var qtyEl = item.querySelector('[data-qty]');
      var qty = parseInt(item.getAttribute('data-quantity') || (qtyEl ? qtyEl.textContent : '1'), 10);
      var packBtn = e.target.closest('[data-pack-qty]');
      if (packBtn) {
        var packQty = parseInt(packBtn.getAttribute('data-pack-qty'), 10);
        if (packQty > 0 && packQty !== qty) changeLine(line, packQty);
        return;
      }
      // Im Zaehler-Modus zaehlen +/− bezahlte Packungen; die Gratis-Packungen
      // kommen in der Warenkorbmenge automatisch dazu.
      var cartLine = lastCart && lastCart.items && lastCart.items[line - 1];
      var counterMode = cartLine ? v2Split(cartLine).counter : packCounter;
      if (counterMode) {
        var paidNow = paidOf(qty);
        if (e.target.closest('[data-qty-up]')) changeLine(line, cartQty(paidNow + 1));
        else if (e.target.closest('[data-qty-down]')) { if (paidNow > 1) changeLine(line, cartQty(paidNow - 1)); }
        else if (e.target.closest('[data-remove]')) changeLine(line, 0);
        return;
      }
      if (e.target.closest('[data-qty-up]')) changeLine(line, qty + 1);
      // Das Minus geht nie unter 1: sonst loescht ein Klick bei Menge 1 das
      // ganze Produkt aus dem Warenkorb – das ueberrascht und liest sich als
      // Bug. Zum Entfernen gibt es die eigene "Entfernen"-Schaltflaeche.
      else if (e.target.closest('[data-qty-down]')) { if (qty > 1) changeLine(line, qty - 1); }
      else if (e.target.closest('[data-remove]')) changeLine(line, 0);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      // Escape raeumt immer nur die oberste Ebene ab: erst den Zwischenschritt,
      // beim naechsten Druck den Drawer.
      if (upsellStepEl && !upsellStepEl.hidden) { dismissUpsellStep(); return; }
      if (root.classList.contains('is-open')) close();
    });

    // ---- Schnelles Hinzufuegen ----
    // Kaufbox und Sticky-Leiste rufen das hier auf. Der Drawer geht sofort auf
    // (mit Ladezustand), statt erst nach drei Abrufen hintereinander. Ob das
    // Paket schon im Warenkorb liegt, steht im zuletzt geladenen Warenkorb –
    // der erste /cart.js-Abruf entfaellt. Liegt es drin, ersetzt change.js die
    // Menge und liefert den ganzen Warenkorb in einem Schritt zurueck.
    function addFromForm(formData) {
      var id = String(formData.get('id') || '');
      var qty = parseInt(formData.get('quantity'), 10) || 1;
      root.classList.add('is-adding');
      open(true);
      var post = function (url, body) {
        return fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      };
      var addFresh = function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }).then(function (r) {
          if (!r.ok) {
            return r.json().catch(function () { return {}; }).then(function (d) {
              var err = new Error(d.description || d.message || '');
              err.shopify = true;
              throw err;
            });
          }
          return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (c) { return c.json(); });
        });
      };
      var known = lastCart ? Promise.resolve(lastCart) : (pendingRefresh || refresh()).then(function () { return lastCart; });
      pendingRefresh = known
        .then(function (cart) {
          var line = packOptions.length && cart && (cart.items || []).filter(function (it) {
            return String(it.variant_id) === id;
          })[0];
          var flOld = flQtyOf(cart, id);
          flAtcMark(id, flOld, line ? qty : flOld + qty);
          if (!line) return addFresh();
          var upd = null;
          if (line._keys && line._keys.length > 1) {
            upd = {};
            line._keys.forEach(function (k, i) { upd[k.key] = i === 0 ? qty : 0; });
          }
          return (upd ? post('/cart/update.js', { updates: upd }) : post('/cart/change.js', { id: line.key, quantity: qty })).then(function (r) {
            if (!r.ok) return addFresh();
            // Der gemerkte Warenkorb kann veraltet sein (z. B. in einem anderen Tab geleert).
            // Fehlt die Zeile danach, normal hinzufügen.
            return r.json().then(function (c) {
              var hit = (c.items || []).some(function (it) { return String(it.variant_id) === id; });
              return hit ? c : addFresh();
            });
          });
        })
        .then(ensureOfferCode)
        .then(function (cart) {
          lastCart = cart;
          render(cart);
          if (cart && cart.item_count > 0) restartReserve();
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: false }));
          return cart;
        })
        .catch(function (e) {
          console.error(e);
          alert((e && e.shopify && e.message) || 'Non è stato possibile aggiungere l’articolo al carrello. Riprova.');
          refresh();
          return null;
        })
        .finally(function () { root.classList.remove('is-adding'); });
      return pendingRefresh;
    }
    window.fnCartDrawer = { add: addFromForm, open: open };

    // Keep contents live whenever the cart changes elsewhere.
    window.addEventListener('cart:updated', function (e) {
      if (e.detail) { lastCart = e.detail; render(e.detail); }
      else refresh();
    });

    // Prime counts on load (no fetch needed if header already has the count).
    if (pageMode) open(); else refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["functions-cart-drawer"]) return;
  try {
    
(function () {
  function init() {
    var root = document.querySelector('[data-cart-drawer]');
    if (!root || root.dataset.fnInit) return;
    root.dataset.fnInit = '1';

    var moneyFormat = root.getAttribute('data-money-format') || '\u007B\u007Bamount\u007D\u007D';
    var fsEnabled = root.getAttribute('data-fs-enabled') === 'true';
    var fsThreshold = parseInt(root.getAttribute('data-fs-threshold'), 10) || 0;
    var fsProgressTpl = root.getAttribute('data-fs-progress') || '';
    var fsSuccessTpl = root.getAttribute('data-fs-success') || '';
    var showUnitPrice = root.getAttribute('data-show-unit-price') === 'true';
    var nightText = root.getAttribute('data-night-text') || '';
    var nightServings = parseInt(root.getAttribute('data-night-servings'), 10) || 0;
    // Feste Paketpreise fuer den Preis pro Nacht, z. B. "1=44,95; 3=89,90"
    // (Menge=Preis in €). Ohne Eintrag zaehlt der Zeilenpreis im Warenkorb.
    var nightPrices = {};
    (root.getAttribute('data-night-prices') || '').split(';').forEach(function (part) {
      var kv = part.split('=');
      var q = parseInt(kv[0], 10);
      var cents = Math.round(parseFloat(String(kv[1] || '').replace(/[^0-9,.]/g, '').replace(/\.(?=.*,)/g, '').replace(',', '.')) * 100);
      if (q > 0 && cents > 0) nightPrices[q] = cents;
    });
    // Das Setting ist ein Textfeld, damit auch "4,95" erlaubt ist – Shopifys
    // number-Setting nimmt keine Nachkommastellen.
    var shippingCost = Math.round(
      (parseFloat(String(root.getAttribute('data-shipping-cost') || '0').replace(/\s/g, '').replace(',', '.')) || 0) * 100
    );
    var offerEnabled = root.getAttribute('data-offer-enabled') === 'true';
    var offerTimerOn = root.getAttribute('data-offer-timer') === 'true';
    var offerTimerPrefix = root.getAttribute('data-offer-timer-prefix') || '';
    var offerCode = (root.getAttribute('data-offer-code') || '').trim();
    // "2:20, 3:30" – Menge zu beworbenem Prozentsatz. Der Warenkorb weist alle
    // Nachlaesse als ein Angebot aus, deshalb steht in der Zeile die beworbene
    // Stufe und nicht die auf zwei Stellen gerechnete echte Quote.
    var offerTiers = (root.getAttribute('data-offer-tiers') || '')
      .split(',')
      .map(function (part) {
        var kv = part.split(':');
        return { qty: parseInt(kv[0], 10), pct: parseFloat(kv[1]) };
      })
      .filter(function (t) { return t.qty > 0 && t.pct > 0; })
      .sort(function (a, b) { return a.qty - b.qty; });

    var upsellFrom = parseInt(root.getAttribute('data-upsell-from'), 10) || 1;
    var upsellTo = parseInt(root.getAttribute('data-upsell-to'), 10) || 2;
    // Gesamtpreis des Zielpakets als Einstellung: Shopify verraet dem Storefront
    // nicht, wie viel ein automatischer Mengenrabatt spaeter abzieht, und ein
    // geschaetzter Prozentsatz waere im Checkout um Cents daneben.
    var upsellTotal = Math.round(
      (parseFloat(String(root.getAttribute('data-upsell-total') || '0').replace(/[^\d,.-]/g, '').replace(',', '.')) || 0) * 100
    );

    var itemsEl = root.querySelector('[data-cart-items]');
    var cardEl = root.querySelector('[data-cart-card]');
    var reviewEl = root.querySelector('[data-cart-review]');
    var emptyEl = root.querySelector('[data-cart-empty]');
    var reserveEl = root.querySelector('[data-cart-reserve]');
    var footEl = root.querySelector('[data-cart-foot]');
    var subtotalEl = root.querySelector('[data-cart-subtotal]');
    var subtotalWasEl = root.querySelector('[data-cart-subtotal-was]');
    var totalsEl = root.querySelector('.fn-cart-drawer__totals');
    var countEl = root.querySelector('[data-cart-drawer-count]');
    var shippingEl = root.querySelector('[data-cart-shipping]');
    var grandTotalEl = root.querySelector('[data-cart-grand-total]');
    var offerRowEl = root.querySelector('[data-offer-row]');
    var offerAmountEl = root.querySelector('[data-offer-amount]');
    var offerLabelEl = root.querySelector('[data-offer-label]');
    var offerLabelTpl = offerLabelEl
      ? (offerLabelEl.getAttribute('data-offer-label-template') || offerLabelEl.textContent)
      : '';
    var offerTimerEl = root.querySelector('[data-offer-timer]');
    var upsellStepEl = root.querySelector('[data-upsell-step]');
    var upsellEl = root.querySelector('[data-upsell]') || upsellStepEl;
    // Angebot rechnet sich gerade? Und wurde es in dieser Sitzung schon gezeigt?
    var upsellReady = false;
    var upsellAsked = false;
    // Wie oft der Zwischenschritt pro Seitenaufruf hoechstens auftauchen darf.
    var upsellAskCount = 0;
    var upsellMaxAsks = 3;
    var checkoutHref = '/checkout';
    // Blendet den Zwischenschritt aus und gibt den Fokus an den Checkout-Button
    // zurueck, damit Tastaturnutzer nicht im ausgeblendeten Dialog stehen.
    function dismissUpsellStep() {
      if (!upsellStepEl || upsellStepEl.hidden) return;
      upsellStepEl.hidden = true;
      // Das X fuehrt zurueck in den Warenkorb, also wird beim naechsten Klick
      // auf "Zur Kasse" wieder gefragt. Wer wirklich ohne zweite Packung
      // weiter will, nimmt den Ablehnen-Link – der geht immer durch. Damit der
      // Button niemand festhaelt, ist die Zahl der Nachfragen begrenzt.
      if (upsellAskCount < upsellMaxAsks) upsellAsked = false;
      var back = root.querySelector('.fn-cart-drawer__checkout');
      if (back && typeof back.focus === 'function') back.focus();
    }
    var upsellTextEl = root.querySelector('[data-upsell-text]');
    var upsellCtaEl = root.querySelector('[data-upsell-cta]');
    var upsellImgEl = root.querySelector('[data-upsell-img]');
    var upsellTextTpl = upsellTextEl ? upsellTextEl.textContent : '';
    var upsellCtaTpl = upsellCtaEl ? upsellCtaEl.textContent : '';
    var upsellServingEl = root.querySelector('[data-upsell-serving]');
    var upsellServingTpl = upsellServingEl ? upsellServingEl.textContent.trim() : '';
    var upsellServings = parseInt(root.getAttribute('data-upsell-servings'), 10) || 0;
    // Feste Pakete statt freier Menge, z. B. "1:1 Packung, 3:2+1 gratis".
    var packOptions = (root.getAttribute('data-pack-options') || '')
      .split(',')
      .map(function (part) {
        var i = part.indexOf(':');
        return { qty: parseInt(part.slice(0, i), 10), label: part.slice(i + 1).trim() };
      })
      .filter(function (o) { return o.qty > 0 && o.label; });
    var packNote = root.getAttribute('data-pack-note') || '';
    var packChip = root.getAttribute('data-pack-chip') || '';
    var hideRemove = root.hasAttribute('data-hide-remove');
    var packImage = root.getAttribute('data-pack-image') || '';

    var fsWrap = root.querySelector('[data-fs-wrap]');
    var fsLabel = root.querySelector('[data-fs-label]');
    var fsFill = root.querySelector('[data-fs-fill]');

    // ---- money formatting (Shopify standard) ----
    function formatWithDelimiters(cents, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(cents) || cents == null) cents = 0;
      var value = (cents / 100).toFixed(precision);
      var parts = value.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }
    function money(cents) {
      var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = m ? m[1] : 'amount';
      var val;
      switch (key) {
        case 'amount_no_decimals': val = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': val = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': val = formatWithDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': val = formatWithDelimiters(cents, 2, ' ', ','); break;
        case 'amount_with_apostrophe_separator': val = formatWithDelimiters(cents, 2, "'", '.'); break;
        default: val = formatWithDelimiters(cents, 2);
      }
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, val);
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function setCounts(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
      if (countEl) countEl.textContent = n;
    }

    // Rabattzeile. Angezeigt wird ausschliesslich der Rabatt, den Shopify
    // wirklich auf Warenkorb-Ebene rechnet – sonst stuende hier ein Nachlass,
    // den der Checkout nicht einloest. Die Prozente selbst kommen aus einem
    // automatischen Rabatt im Shopify-Admin, nicht aus dem Theme.
    // /cart.js und /cart/change.js liefern dieselbe Information in zwei Formen:
    // einmal flach mit total_allocated_amount, einmal verschachtelt als
    // { amount, discount_application }. Beides muss gelesen werden, sonst faellt
    // die Zeile nach jeder Mengenaenderung wieder weg.
    function offerSum(cart) {
      var apps = (cart && cart.cart_level_discount_applications) || [];
      var sum = 0;
      for (var i = 0; i < apps.length; i++) {
        var a = apps[i];
        sum += a.total_allocated_amount || a.amount ||
          (a.discount_application && a.discount_application.total_allocated_amount) || 0;
      }
      return sum;
    }

    // Shopify verwirft einen Code, der auf einen Warenkorb gelegt wird, der die
    // Mindestmenge noch nicht erreicht – genau der Normalfall, wenn die Seite
    // mit leerem Warenkorb geladen und erst danach etwas hinzugefuegt wird.
    // Deshalb wird der Code nicht einmal pro Seitenaufruf gesetzt, sondern immer
    // dann erneut, wenn sich die Menge geaendert hat und noch kein Rabatt
    // gerechnet wird. Greift er, liefert der zweite Aufruf den Warenkorb mit
    // Rabatt zurueck; greift er nicht, bleibt alles wie es war.
    var offerTriedCount = -1;
    function ensureOfferCode(cart) {
      if (!offerEnabled || !offerCode) return Promise.resolve(cart);
      if (offerSum(cart) > 0) return Promise.resolve(cart);
      if (cart && cart.item_count === offerTriedCount) return Promise.resolve(cart);
      offerTriedCount = cart ? cart.item_count : -1;
      return fetch('/discount/' + encodeURIComponent(offerCode), { credentials: 'same-origin' })
        .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .catch(function () { return cart; });
    }

    // Listenpreis ohne jeden Nachlass \u2013 3 x 49,95 statt des Paketpreises.
    function fullPrice(cart) {
      var items = (cart && cart.items) || [];
      return items.reduce(function (sum, it) { return sum + it.original_line_price; }, 0);
    }

    // Normalfall sind die gepflegten Stufen: der Warenkorb soll denselben
    // gerundeten Prozentsatz nennen wie die Paketauswahl auf der PDP (20/30),
    // sonst steht ueber der Karte 20 % und darunter 19 %. Nur wenn keine Stufe
    // zur Menge passt, wird der wirklich gewaehrte Rabatt gerechnet – dann
    // abgerundet, damit nie mehr Ersparnis ausgewiesen wird, als der Checkout
    // abzieht.
    function offerPct(cart, discount) {
      var qty = (cart && cart.item_count) || 0;
      var tier = null;
      for (var i = 0; i < offerTiers.length; i++) {
        if (qty >= offerTiers[i].qty) tier = offerTiers[i].pct;
      }
      var full = fullPrice(cart);
      if (full <= 0) return tier;
      var real = (discount / full) * 100;
      // Die gepflegte Stufe wird nur genannt, solange sie zum tatsaechlich
      // gewaehrten Rabatt passt. Liegt zusaetzlich ein Code auf dem Warenkorb
      // – etwa aus einer alten Aktion, die noch in der Sitzung des Kunden
      // steckt – stuende sonst "-15 %" neben einem Betrag von 19 %.
      if (tier !== null && Math.abs(real - tier) <= 1) return tier;
      return Math.floor(real);
    }

    // Der Warenkorb weist alle Nachlaesse zusammen in einer Zeile
    // aus: oben stehen die Listenpreise, hier steht der gesamte Nachlass. Sonst
    // muesste der Kunde zwei Rabatte gegen eine ungerabattete Zwischensumme
    // verrechnen und die Gesamtsumme ginge nicht mehr auf.
    function renderOffer(cart) {
      if (!offerEnabled || !offerRowEl) return;
      var sum = fullPrice(cart) - ((cart && cart.total_price) || 0);
      if (sum <= 0) { offerRowEl.hidden = true; stopTimer(); return; }
      offerRowEl.hidden = false;
      if (offerAmountEl) offerAmountEl.innerHTML = '\u2212' + money(sum);
      if (offerLabelEl) {
        var pct = offerPct(cart, sum);
        offerLabelEl.textContent = offerLabelTpl.replace(
          /\{\{\s*pct\s*\}\}|\[pct\]/i,
          pct === null ? '' : String(pct).replace('.', ',')
        );
      }
      startTimer();
    }

    // Countdown bis zur lokalen Mitternacht. Er rechnet die Restzeit bei jedem
    // Tick neu aus der Uhr, statt herunterzuzaehlen – so laeuft er nach einem
    // Standby oder Tabwechsel nicht falsch und beginnt um 00:00 von selbst neu.
    var timerId = null;
    function tickTimer() {
      if (!offerTimerEl) return;
      var now = new Date();
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var left = Math.max(0, Math.floor((midnight - now) / 1000));
      var h = Math.floor(left / 3600);
      var m = Math.floor((left % 3600) / 60);
      var sec = left % 60;
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      offerTimerEl.textContent = (offerTimerPrefix ? offerTimerPrefix + ' ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
      offerTimerEl.hidden = false;
    }
    function startTimer() {
      if (!offerTimerOn || !offerTimerEl || timerId) return;
      tickTimer();
      timerId = setInterval(tickTimer, 1000);
    }
    function stopTimer() {
      if (timerId) { clearInterval(timerId); timerId = null; }
      if (offerTimerEl) offerTimerEl.hidden = true;
    }

    // ---- Angebotsleiste am Seitenanfang ----
    // Das Markup liegt in dieser Section, weil der Drawer auf jeder Seite
    // eingebunden ist; hier wandert es an den Anfang des Body.
    var topBar = document.querySelector('[data-offer-topbar]');
    if (topBar && topBar.parentNode !== document.body) {
      document.body.insertBefore(topBar, document.body.firstChild);
    }
    var topTextEl = topBar && topBar.querySelector('[data-offer-topbar-text]');
    var topTimerEl = topBar && topBar.querySelector('[data-offer-topbar-timer]');
    var topMin = topBar ? parseInt(topBar.getAttribute('data-min'), 10) || 0 : 0;
    var topLabel = topBar ? topBar.getAttribute('data-label') || '' : '';
    var topHint = topBar ? topBar.getAttribute('data-hint') || '' : '';
    var topTimerOn = topBar ? topBar.getAttribute('data-timer') === 'true' : false;
    var topTimerId = null;

    function pad2(n) { return n < 10 ? '0' + n : String(n); }
    function tickTopTimer() {
      if (!topTimerEl) return;
      var now = new Date();
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var left = Math.max(0, Math.floor((midnight - now) / 1000));
      topTimerEl.textContent = pad2(Math.floor(left / 3600)) + ':' +
        pad2(Math.floor((left % 3600) / 60)) + ':' + pad2(left % 60);
      topTimerEl.hidden = false;
    }
    function startTopTimer() {
      if (!topTimerOn || !topTimerEl || topTimerId) return;
      tickTopTimer();
      topTimerId = setInterval(tickTopTimer, 1000);
    }
    function stopTopTimer() {
      if (topTimerId) { clearInterval(topTimerId); topTimerId = null; }
      if (topTimerEl) topTimerEl.hidden = true;
    }

    // ---- Reservierungs-Countdown ----
    // Zaehlt von X Minuten auf 00:00 und haelt dort an. Die Deadline liegt in
    // sessionStorage, damit der Timer beim erneuten Oeffnen des Drawers weiter-
    // laeuft statt neu zu starten; bei leerem Warenkorb wird sie geloescht, damit
    // ein neuer Warenkorb wieder volle Zeit bekommt. Restzeit wird bei jedem Tick
    // aus der Deadline gerechnet (standby-/tabwechsel-fest).
    var reserveMin = reserveEl ? parseFloat(reserveEl.getAttribute('data-reserve-min')) || 0 : 0;
    var reserveTpl = reserveEl ? (reserveEl.getAttribute('data-reserve-text') || '') : '';
    var reserveTimeEl = null;
    var reserveId = null;
    var RESERVE_KEY = 'fnCartReserveUntil';

    function reserveDeadline(create) {
      var v = null;
      try { v = sessionStorage.getItem(RESERVE_KEY); } catch (e) {}
      var ts = v ? parseInt(v, 10) : 0;
      if ((!ts || isNaN(ts)) && create) {
        ts = new Date().getTime() + Math.round(reserveMin * 60000);
        try { sessionStorage.setItem(RESERVE_KEY, String(ts)); } catch (e) {}
      }
      return ts || 0;
    }
    function clearReserveDeadline() {
      try { sessionStorage.removeItem(RESERVE_KEY); } catch (e) {}
    }
    function buildReserveMsg() {
      if (!reserveEl || reserveTimeEl) return;
      var msg = reserveEl.querySelector('[data-reserve-msg]');
      if (!msg) return;
      var parts = reserveTpl.split('[time]');
      msg.textContent = '';
      msg.appendChild(document.createTextNode(parts[0] || ''));
      reserveTimeEl = document.createElement('span');
      reserveTimeEl.className = 'fn-cart-drawer__reserve-time';
      reserveTimeEl.setAttribute('data-reserve-timer', '');
      msg.appendChild(reserveTimeEl);
      msg.appendChild(document.createTextNode(parts.length > 1 ? parts.slice(1).join('[time]') : ''));
    }
    function tickReserve() {
      if (!reserveTimeEl) return;
      var ts = reserveDeadline(false);
      var left = ts ? Math.floor((ts - new Date().getTime()) / 1000) : 0;
      if (left <= 0) {
        // Abgelaufen -> der Timer beginnt sofort wieder von vorn (neue Frist).
        ts = new Date().getTime() + Math.round(reserveMin * 60000);
        try { sessionStorage.setItem(RESERVE_KEY, String(ts)); } catch (e) {}
        left = Math.round(reserveMin * 60);
      }
      var m = Math.floor(left / 60);
      var s = left % 60;
      reserveTimeEl.textContent = m + ':' + (s < 10 ? '0' + s : String(s));
    }
    function startReserve() {
      if (!reserveEl || reserveMin <= 0) return;
      buildReserveMsg();
      reserveDeadline(true); // Deadline anlegen, falls noch keine
      reserveEl.hidden = false;
      tickReserve();
      if (!reserveId) reserveId = setInterval(tickReserve, 1000);
    }
    function stopReserve() {
      if (reserveId) { clearInterval(reserveId); reserveId = null; }
      if (reserveEl) reserveEl.hidden = true;
    }
    // Bei jeder Mengenaenderung beginnt die Reservierungsfrist von vorn.
    function restartReserve() {
      if (!reserveEl || reserveMin <= 0) return;
      clearReserveDeadline();
      reserveDeadline(true);
      if (reserveTimeEl) tickReserve();
    }

    // ---- Lagerbestand-Check ----
    // Spielt einmal pro Session die Pruef-Animation (Balken + Zahnrad),
    // kippt in „auf Lager!" und blendet danach den Reservierungs-Timer ein.
    // render() laeuft bei jeder Warenkorb-Aenderung erneut, deshalb haelt
    // stockState fest, ob die Animation fuer dieses Oeffnen schon lief.
    var stockEl = root.querySelector('[data-cart-stockcheck]');
    var stockState = 'idle'; // idle | running | done (pro Oeffnen)
    var stockTimers = [];
    // Die Pruef-Animation laeuft nur einmal pro Session; danach (und auch wenn
    // der Timer schon einmal abgelaufen war) erscheint sofort der fertige
    // gruene Zustand ohne erneutes "Pruefen".
    var STOCK_KEY = 'fnCartStockChecked';
    function stockChecked() {
      try { return sessionStorage.getItem(STOCK_KEY) === '1'; } catch (e) { return false; }
    }
    function markStockChecked() {
      try { sessionStorage.setItem(STOCK_KEY, '1'); } catch (e) {}
    }
    function showStockDone() {
      if (!stockEl) return;
      stockTimers.forEach(clearTimeout);
      stockTimers = [];
      var fill = stockEl.querySelector('[data-stockcheck-fill]');
      var badge = stockEl.querySelector('[data-stockcheck-badge]');
      var label = stockEl.querySelector('[data-stockcheck-label]');
      if (fill) { fill.style.transition = 'none'; fill.style.width = '100%'; }
      if (badge) { badge.style.transition = 'none'; badge.style.left = '100%'; }
      if (label) label.textContent = stockEl.getAttribute('data-done-text') || '';
      stockEl.classList.add('is-done');
      stockEl.classList.add('has-timer');
      stockEl.hidden = false;
      stockState = 'done';
    }
    function resetStockCheck() {
      stockTimers.forEach(clearTimeout);
      stockTimers = [];
      stockState = 'idle';
      if (stockEl) {
        stockEl.hidden = true;
        stockEl.classList.remove('is-done');
        stockEl.classList.remove('has-timer');
      }
    }
    function startScarcity() {
      if (!stockEl || stockState === 'done') { startReserve(); return; }
      if (stockState === 'running') return; // Abschluss startet den Timer selbst
      if (stockChecked()) { showStockDone(); startReserve(); return; }
      // render() laeuft auch bei geschlossenem Drawer (Seitenladung, Add-to-Cart
      // im Hintergrund). Die einmalige Animation soll aber erst beim ersten
      // echten Oeffnen sichtbar ablaufen — sonst waere sie schon "verbraucht".
      if (!root.classList.contains('is-open')) return;
      stockState = 'running';
      if (reserveEl) reserveEl.hidden = true;
      var fill = stockEl.querySelector('[data-stockcheck-fill]');
      var badge = stockEl.querySelector('[data-stockcheck-badge]');
      var label = stockEl.querySelector('[data-stockcheck-label]');
      var dur = (parseFloat(stockEl.getAttribute('data-check-seconds')) || 2) * 1000;
      try { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) dur = 0; } catch (e) {}
      stockEl.classList.remove('is-done');
      if (label) label.textContent = stockEl.getAttribute('data-check-text') || '';
      // Startzustand ohne Uebergang setzen, erst im uebernaechsten Frame
      // animieren – sonst springt der Balken direkt auf 100 %.
      if (fill) { fill.style.transition = 'none'; fill.style.width = '0%'; }
      if (badge) { badge.style.transition = 'none'; badge.style.left = '0%'; }
      stockEl.hidden = false;
      if (fill) void fill.offsetWidth; // Startzustand ins Layout zwingen (Reflow)
      // Zwei Schritte: erst bis 1/3 („wird geprueft…", Zahnrad dreht in der
      // Denkpause weiter), dann volles Banner („auf Lager!"). Die Gesamtdauer
      // aus dem Editor wird auf Anlauf/Pause/Endspurt verteilt.
      var t1 = Math.round(dur * 0.3), hold = Math.round(dur * 0.55), t2 = Math.round(dur * 0.15);
      var ease = 'ms cubic-bezier(0.3, 0.6, 0.3, 1)';
      stockTimers.push(setTimeout(function () {
        if (fill) { fill.style.transition = 'width ' + t1 + ease; fill.style.width = '33.3%'; }
        if (badge) { badge.style.transition = 'left ' + t1 + ease; badge.style.left = '33.3%'; }
      }, 30));
      stockTimers.push(setTimeout(function () {
        if (fill) { fill.style.transition = 'width ' + t2 + ease; fill.style.width = '100%'; }
        if (badge) { badge.style.transition = 'left ' + t2 + ease; badge.style.left = '100%'; }
      }, 30 + t1 + hold));
      stockTimers.push(setTimeout(function () {
        stockEl.classList.add('is-done');
        if (label) label.textContent = stockEl.getAttribute('data-done-text') || '';
      }, 30 + t1 + hold + t2 + 60));
      // Banner bleibt stehen; der Timer dockt platzsparend darunter an.
      stockTimers.push(setTimeout(function () {
        stockEl.classList.add('has-timer');
        stockState = 'done';
        markStockChecked(); // ab jetzt fuer den Rest der Session nur noch der fertige Zustand
        startReserve();
      }, 30 + t1 + hold + t2 + 660));
    }

    // Auf der Produktseite zaehlt das gerade gewaehlte Paket, sonst nur der
    // Warenkorb – so ist die Leiste schon aktiv, bevor etwas hinzugefuegt wurde.
    function selectedPackQty() {
      var card = document.querySelector('[data-variant-wrap] [data-variant-card][aria-checked="true"]');
      var wrap = card && card.closest('[data-variant-wrap]');
      return wrap ? parseInt(wrap.getAttribute('data-variant-qty'), 10) || 0 : 0;
    }

    function renderTopBar(cart) {
      if (!topBar) return;
      var count = Math.max(cart ? cart.item_count || 0 : 0, selectedPackQty());
      var active = topMin > 0 && count >= topMin;
      var text = active ? topLabel : topHint;
      if (!text) { topBar.hidden = true; stopTopTimer(); return; }
      topBar.hidden = false;
      topBar.classList.toggle('fn-offer-bar--hint', !active);
      if (topTextEl) topTextEl.textContent = text;
      if (active) startTopTimer();
      else stopTopTimer();
    }

    // Paketwechsel auf der Produktseite sofort spiegeln.
    if (topBar) {
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-variant-card]')) {
          setTimeout(function () { renderTopBar(lastCart); }, 0);
        }
      });
      renderTopBar(null);
    }

    // Eigene Versandzeile plus Gesamtsumme. Die Freigrenze ist dieselbe wie beim
    // Fortschrittsbalken, damit Zeile und Balken nie widersprüchlich stehen.
    function renderSums(cart) {
      var total = (cart && cart.total_price) || 0;
      var free = fsThreshold > 0 && total >= fsThreshold;
      var ship = free ? 0 : shippingCost;
      // Auch bei Gratis-Versand steht hier eine Zahl, damit die Spalte durchgehend
      // Betraege zeigt statt einmal Text und einmal Summe.
      if (shippingEl) {
        shippingEl.innerHTML = free || ship === 0
          ? '<span class="fn-cart-drawer__shipping-free">' + money(0) + '</span>'
          : money(ship);
      }
      if (grandTotalEl) {
        grandTotalEl.innerHTML = money(total + ship);
        // Orange nur, wenn ein Rabatt greift – beim Einzelpack bleibt sie schwarz.
        grandTotalEl.classList.toggle('is-offer', fullPrice(cart) - total > 0);
      }
    }

    // Versandkosten zu einer beliebigen Summe – dieselbe Freigrenze wie in der
    // Versandzeile, damit Angebot und Rechnung nicht auseinanderlaufen.
    function shippingFor(total) {
      return fsThreshold > 0 && total >= fsThreshold ? 0 : shippingCost;
    }

    // Der Aufpreis fuer die zweite Packung: Endsumme des Zielpakets inklusive
    // Versand minus dem, was gerade im Warenkorb steht. Der gesparte Versand
    // steckt damit automatisch im Betrag.
    function renderUpsell(cart) {
      upsellReady = false;
      if (!upsellEl) return;
      var items = (cart && cart.items) || [];
      var qty = (cart && cart.item_count) || 0;
      if (items.length !== 1 || qty !== upsellFrom || upsellTotal <= 0 || upsellTo <= upsellFrom) {
        hideUpsell();
        return;
      }
      var now = cart.total_price + shippingFor(cart.total_price);
      var then = upsellTotal + shippingFor(upsellTotal);
      var diff = then - now;
      // Ein Aufpreis, der den regulaeren Packungspreis erreicht, ist kein
      // Angebot mehr – dann bleibt der Kasten lieber weg.
      // Bei 1 -> 3 (2+1 gratis) kommen zwei Packungen dazu; der Vergleichspreis
      // ist dann der Listenpreis beider Packungen.
      var regular = Math.round(items[0].original_line_price / items[0].quantity) * (upsellTo - upsellFrom);
      if (diff <= 0 || diff >= regular) { hideUpsell(); return; }

      var vals = {
        diff: money(diff),
        regular: money(regular),
        save: money(regular - diff),
        shipping: money(shippingFor(cart.total_price))
      };
      // Portionspreis der zweiten Packung: der Aufpreis geteilt durch die
      // Portionen einer Packung. Gerundet auf den Cent – bei 30 Nächten steht
      // dort dieselbe Groessenordnung wie im Preis-pro-Nacht auf der PDP.
      if (upsellServings > 0) vals.serving = money(Math.round(diff / upsellServings));
      if (upsellServingEl) {
        upsellServingEl.hidden = !vals.serving;
        if (vals.serving) upsellServingEl.innerHTML = fill(upsellServingTpl, vals);
      }
      if (upsellTextEl) upsellTextEl.innerHTML = fill(upsellTextTpl, vals);
      if (upsellCtaEl) upsellCtaEl.innerHTML = fill(upsellCtaTpl, vals);
      // Reine Zahlenfelder der Preiskachel – hier steht kein Editor-Text drum
      // herum, also wird der Betrag direkt gesetzt.
      upsellEl.querySelectorAll('[data-upsell-fill]').forEach(function (el) {
        var key = el.getAttribute('data-upsell-fill');
        if (vals[key]) el.textContent = vals[key];
      });
      // Das Produktbild kommt aus der Warenkorbzeile, damit im Editor kein
      // zweites Bild gepflegt werden muss, das spaeter auseinanderlaeuft.
      if (upsellImgEl) {
        var src = items[0].image ? items[0].image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
        upsellImgEl.hidden = !src;
        if (src) {
          upsellImgEl.src = src;
          upsellImgEl.alt = items[0].product_title || '';
        }
      }
      upsellReady = true;
      // Als Zwischenschritt bleibt das Angebot verdeckt, bis der Kunde auf
      // "Zur Kasse" geht – im Warenkorb steht es dagegen sofort da.
      if (!upsellStepEl) upsellEl.hidden = false;
    }

    function hideUpsell() {
      upsellReady = false;
      upsellEl.hidden = true;
    }

    // Platzhalter in den Editor-Texten ersetzen; **fett** bleibt wie in den
    // Versandtexten erlaubt. Bevorzugt [diff]: geschweifte Klammern stehen bis
    // zum Ersetzen im Quelltext und lesen sich fuer Crawler wie ein kaputtes
    // Liquid-Template. Die alte Schreibweise bleibt der Vollstaendigkeit halber.
    function fill(tpl, vals) {
      return bold(esc(tpl)).replace(/\{\{\s*(\w+)\s*\}\}|\[(\w+)\]/g, function (m, k1, k2) {
        var key = k1 || k2;
        return Object.prototype.hasOwnProperty.call(vals, key) ? '<b>' + vals[key] + '</b>' : m;
      });
    }

    function renderShipping(total) {
      if (!fsEnabled || !fsWrap || fsThreshold <= 0) { if (fsWrap) fsWrap.hidden = true; return; }
      fsWrap.hidden = false;
      // Gemessen wird am Warenwert (Zwischensumme), NICHT an der Endsumme inkl.
      // Versand – die Gratis-Versand-Freigrenze im Shop bezieht sich auf den
      // Warenwert. Sonst zeigt der leere Warenkorb 75,01 statt der echten 80.
      var pct = Math.min(100, Math.round((total / fsThreshold) * 100));
      if (fsFill) fsFill.style.width = pct + '%';
      if (total >= fsThreshold) {
        fsLabel.innerHTML = bold(esc(fsSuccessTpl));
      } else {
        var gap = fsThreshold - total;
        var remaining = '<b>' + money(gap) + '</b>';
        // The amount placeholder in the setting is replaced with the remaining sum.
        fsLabel.innerHTML = bold(esc(fsProgressTpl)).replace(/\{\{\s*amount\s*\}\}|\[amount\]/i, remaining);
      }
    }

    // *stars* in the shipping labels become bold, so merchants can emphasise the
    // opening words ("**Perfekt!** Wir schenken dir den Versand.") from the editor.
    function bold(s) {
      return s.replace(/\*\*(.+?)\*\*/g, '<b>$1</b>');
    }

    function render(cart) {
      if (!cart) return;
      setCounts(cart.item_count);
      renderShipping(cart.total_price);
      renderSums(cart);
      renderOffer(cart);
      renderUpsell(cart);
      renderTopBar(cart);

      if (!cart.items || !cart.items.length) {
        itemsEl.innerHTML = '';
        if (cardEl) cardEl.hidden = true;
        if (reviewEl) reviewEl.hidden = true;
        emptyEl.hidden = false;
        footEl.hidden = true;
        stopReserve();
        resetStockCheck(); // leerer Warenkorb → Check beim naechsten Mal neu
        clearReserveDeadline(); // leerer Warenkorb → neuer Timer beim naechsten Mal
        return;
      }
      emptyEl.hidden = true;
      if (cardEl) cardEl.hidden = false;
      if (reviewEl) reviewEl.hidden = false;
      footEl.hidden = false;
      startScarcity();
      // Zwischensumme zum Listenpreis. Jeder Nachlass steht weiter unten in der
      // Summer-Offer-Zeile, deshalb bleibt hier nichts durchgestrichen.
      subtotalEl.innerHTML = money(fullPrice(cart));
      if (subtotalWasEl) {
        subtotalWasEl.innerHTML = '';
        subtotalWasEl.hidden = true;
      }
      if (totalsEl) totalsEl.classList.add('is-full');

      itemsEl.innerHTML = cart.items.map(function (item, i) {
        var line = i + 1;
        var img = item.image ? esc(item.image) : (item.featured_image && item.featured_image.url ? esc(item.featured_image.url) : '');
        var sub = [];
        if (item.product_has_only_default_variant === false && item.variant_title) sub.push(esc(item.variant_title));
        if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
          sub.push(esc(item.selling_plan_allocation.selling_plan.name));
        }
        var subHtml = sub.length ? '<span class="fn-cart-drawer__variant">' + sub.join(' · ') + '</span>' : '';
        // Beim Bundle (z. B. 2+1) zeigt das Vorschaubild alle Packungen.
        var isBundle = packOptions.some(function (o) { return o.qty > 1 && o.qty === item.quantity; });
        if (isBundle && packImage) img = esc(packImage);
        var thumb = img ? '<img class="fn-cart-drawer__thumb' + (isBundle && packImage ? ' fn-cart-drawer__thumb--bundle' : '') + '" src="' + img + '" alt="' + esc(item.product_title) + '" width="84" height="84" loading="lazy">' : '<span class="fn-cart-drawer__thumb"></span>';

        // Bei Mengenrabatt (2er/3er) steht der neue Paketpreis vorne, der
        // Listenpreis daneben durchgestrichen. Der neue Preis wird aus dem
        // wirklich gewaehrten Rabatt abgeleitet (Listenpreis anteilig auf die
        // rabattierte Warenkorbsumme skaliert), nicht aus einem geschaetzten
        // Prozentsatz – so trifft die Zeile den Betrag im Checkout auf den Cent
        // und passt zur Gesamtsumme unten. Beim 1er greift kein Rabatt: dann
        // steht wie bisher nur der Listenpreis da.
        var lineFull = fullPrice(cart);
        var lineDisc = lineFull - ((cart && cart.total_price) || 0);
        var lineNow = lineDisc > 0 && lineFull > 0
          ? Math.round(item.original_line_price * ((cart.total_price) / lineFull))
          : item.original_line_price;
        var priceHtml = '<div class="fn-cart-drawer__prices">' +
          (lineNow < item.original_line_price
            ? '<span class="fn-cart-drawer__now">' + money(lineNow) + '</span>' +
              '<span class="fn-cart-drawer__was">' + money(item.original_line_price) + '</span>'
            : '<span class="fn-cart-drawer__now">' + money(item.original_line_price) + '</span>') +
          '</div>';

        // Preis pro Nacht: der Zeilenpreis (nach Rabatt) geteilt durch alle
        // Naechte der Zeile – Menge x Portionen je Packung.
        var nightHtml = '';
        if (nightText && nightServings > 0 && item.quantity > 0) {
          var nightBase = nightPrices[item.quantity] || lineNow;
          var perNight = money(Math.round(nightBase / (item.quantity * nightServings)));
          nightHtml = '<span class="fn-cart-drawer__per-night">' + esc(nightText).replace(/\[price\]/g, '<b>' + perNight + '</b>') + '</span>';
        }

        // Shopify only sends unit_price for products that declare a unit measure.
        // Off by default: next to a pack price the per-kg figure reads as a
        // second, contradictory price.
        var unitHtml = '';
        if (showUnitPrice && item.unit_price && item.unit_price_measurement) {
          var m = item.unit_price_measurement;
          var ref = (m.reference_value && m.reference_value !== 1 ? m.reference_value : '') + (m.reference_unit || '');
          unitHtml = '<span class="fn-cart-drawer__unit">(' + money(item.unit_price) + (ref ? '/' + esc(ref) : '') + ')</span>';
        }

        // Pakete statt +/-: nur die gepflegten Mengen sind waehlbar.
        var packHtml = '';
        var chipHtml = '';
        if (packOptions.length) {
          var activePack = null;
          packHtml = '<div class="fn-cart-drawer__packs" role="group" aria-label="Paket">' +
            packOptions.map(function (o) {
              var on = o.qty === item.quantity;
              if (on) activePack = o;
              return '<button type="button" data-pack-qty="' + o.qty + '" aria-pressed="' + on + '"' +
                (on ? ' class="is-active"' : '') + '>' + esc(o.label) + '</button>';
            }).join('') +
            '</div>';
          if (activePack && activePack.qty > 1) {
            chipHtml = '<span class="fn-cart-drawer__pack-chip">' + esc(packChip || activePack.label) + '</span>' +
              (packNote ? '<span class="fn-cart-drawer__variant">' + esc(packNote.replace(/\[qty\]/g, item.quantity)) + '</span>' : '');
          }
        }
        var qtyHtml = packOptions.length ? '' :
          '<div class="fn-cart-drawer__qty">' +
            '<button type="button" data-qty-down aria-label="Menge verringern"' + (item.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
            '<span data-qty>' + item.quantity + '</span>' +
            '<button type="button" data-qty-up aria-label="Menge erhöhen">+</button>' +
          '</div>';

        return '' +
          '<li class="fn-cart-drawer__item' + (packOptions.length ? ' has-packs' : '') + '" data-line="' + line + '" data-quantity="' + item.quantity + '">' +
            thumb +
            '<div class="fn-cart-drawer__info">' +
              '<a class="fn-cart-drawer__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
              chipHtml +
              priceHtml +
              nightHtml +
              unitHtml +
              subHtml +
            '</div>' +
            '<div class="fn-cart-drawer__side">' +
              qtyHtml +
              (hideRemove ? '' : '<button type="button" class="fn-cart-drawer__remove" data-remove>Entfernen</button>') +
            '</div>' +
            packHtml +
          '</li>';
      }).join('');
    }

    var lastCart = null;
    // Der laufende Warenkorb-Abruf. Der Checkout-Klick wartet darauf, damit der
    // Zwischenschritt nicht verschluckt wird, wenn jemand sofort klickt.
    var pendingRefresh = null;
    function refresh() {
      root.classList.add('is-loading');
      pendingRefresh = fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(ensureOfferCode)
        .then(function (cart) { lastCart = cart; render(cart); })
        .finally(function () { root.classList.remove('is-loading'); });
      return pendingRefresh;
    }

    function changeLine(line, quantity) {
      root.classList.add('is-loading');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(ensureOfferCode)
        .then(function (cart) {
          lastCart = cart;
          render(cart);
          // Mengenaenderung -> Reservierungsfrist beginnt von vorn (nur wenn noch
          // etwas im Warenkorb ist; beim Leeren uebernimmt render das Stoppen).
          if (cart && cart.item_count > 0) restartReserve();
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .finally(function () { root.classList.remove('is-loading'); });
    }

    // ---- open / close ----
    var pageMode = root.getAttribute('data-page-mode') === 'true';
    function open(skipRefresh) {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('fn-cart-locked');
      if (stockChecked()) {
        showStockDone(); // schon geprueft → fertiger Zustand, keine neue Animation
      } else {
        resetStockCheck(); // erste Pruefung dieser Session laeuft animiert
        if (stockEl && reserveEl) reserveEl.hidden = true; // kein Timer-Blitzer vor dem Check
      }
      if (skipRefresh !== true) refresh();
      var closeBtn = root.querySelector('.fn-cart-drawer__close');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      // Auf /cart gibt es keine Seite "hinter" dem Warenkorb: Schliessen fuehrt zur Startseite.
      if (pageMode) { window.location.href = '/'; return; }
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('fn-cart-locked');
      // Wer den Warenkorb ganz zumacht, faengt beim naechsten Oeffnen neu an:
      // sonst bliebe das Angebot nach einem einzigen Blick fuer den Rest des
      // Seitenaufrufs stumm. Pro Oeffnen wird weiterhin hoechstens einmal
      // gefragt, der Zwischenschritt startet dabei immer geschlossen.
      upsellAsked = false;
      upsellAskCount = 0;
      if (upsellStepEl) upsellStepEl.hidden = true;
    }

    // Zurueck-Taste aus der Kasse: der Browser holt die Seite aus dem Cache,
    // samt aller Merker. Ohne das hier bliebe das Angebot danach stumm.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      upsellAsked = false;
      upsellAskCount = 0;
      if (upsellStepEl) upsellStepEl.hidden = true;
    });

    // Intercept the header cart trigger (also fires for the programmatic
    // .click() that functions-product.js runs after add-to-cart).
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cart-drawer-trigger]');
      if (trigger) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-cart-close]')) { close(); return; }
      // Der Checkout-Button haelt einmal an, solange das Angebot noch steht.
      var checkoutLink = e.target.closest('.fn-cart-drawer__checkout');
      if (checkoutLink && upsellStepEl && !upsellAsked) {
        checkoutHref = checkoutLink.getAttribute('href') || '/checkout';
        if (upsellReady) {
          e.preventDefault();
          upsellAsked = true;
          upsellAskCount++;
          upsellStepEl.hidden = false;
          return;
        }
        // Der Warenkorb wird noch geladen – wer sofort klickt, hat den Schritt
        // sonst nie gesehen. Der Klick wartet kurz auf die Antwort und geht
        // spaetestens nach 1,2 s so oder so zur Kasse.
        if (pendingRefresh) {
          e.preventDefault();
          var done = false;
          var goOnToCheckout = function () {
            if (done) return;
            done = true;
            window.location.href = checkoutHref;
          };
          var fallback = setTimeout(goOnToCheckout, 1200);
          Promise.resolve(pendingRefresh)
            .catch(function () {})
            .then(function () {
              clearTimeout(fallback);
              if (done) return;
              if (upsellReady && !upsellAsked) {
                done = true;
                upsellAsked = true;
                upsellAskCount++;
                upsellStepEl.hidden = false;
                return;
              }
              goOnToCheckout();
            });
          return;
        }
      }

      // Die zweite Packung ist dieselbe Variante, also reicht das Hochsetzen der
      // Zeilenmenge – ein zweites /cart/add wuerde eine zweite Zeile anlegen.
      if (e.target.closest('[data-upsell-cta]')) {
        var goOn = !!e.target.closest('[data-upsell-continue]');
        changeLine(1, upsellTo).then(function () {
          // Im Zwischenschritt hat der Kunde die Kasse schon angesteuert, also
          // wird er dorthin durchgereicht statt zurueck in den Warenkorb.
          if (goOn) window.location.href = checkoutHref;
        });
        return;
      }
      if (e.target.closest('[data-upsell-skip]')) {
        window.location.href = checkoutHref;
        return;
      }
      // Das X schliesst nur den Zwischenschritt und laesst den Kunden im
      // Warenkorb. Gefragt wird trotzdem nicht noch einmal – upsellAsked steht
      // bereits, sonst haenge der naechste Klick auf "Zur Kasse" wieder fest.
      if (e.target.closest('[data-upsell-dismiss]')) {
        dismissUpsellStep();
        return;
      }

      var item = e.target.closest('.fn-cart-drawer__item');
      if (!item || !root.contains(item)) return;
      var line = parseInt(item.getAttribute('data-line'), 10);
      var qtyEl = item.querySelector('[data-qty]');
      var qty = parseInt(item.getAttribute('data-quantity') || (qtyEl ? qtyEl.textContent : '1'), 10);
      var packBtn = e.target.closest('[data-pack-qty]');
      if (packBtn) {
        var packQty = parseInt(packBtn.getAttribute('data-pack-qty'), 10);
        if (packQty > 0 && packQty !== qty) changeLine(line, packQty);
        return;
      }
      if (e.target.closest('[data-qty-up]')) changeLine(line, qty + 1);
      // Das Minus geht nie unter 1: sonst loescht ein Klick bei Menge 1 das
      // ganze Produkt aus dem Warenkorb – das ueberrascht und liest sich als
      // Bug. Zum Entfernen gibt es die eigene "Entfernen"-Schaltflaeche.
      else if (e.target.closest('[data-qty-down]')) { if (qty > 1) changeLine(line, qty - 1); }
      else if (e.target.closest('[data-remove]')) changeLine(line, 0);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      // Escape raeumt immer nur die oberste Ebene ab: erst den Zwischenschritt,
      // beim naechsten Druck den Drawer.
      if (upsellStepEl && !upsellStepEl.hidden) { dismissUpsellStep(); return; }
      if (root.classList.contains('is-open')) close();
    });

    // ---- Schnelles Hinzufuegen ----
    // Kaufbox und Sticky-Leiste rufen das hier auf. Der Drawer geht sofort auf
    // (mit Ladezustand), statt erst nach drei Abrufen hintereinander. Ob das
    // Paket schon im Warenkorb liegt, steht im zuletzt geladenen Warenkorb –
    // der erste /cart.js-Abruf entfaellt. Liegt es drin, ersetzt change.js die
    // Menge und liefert den ganzen Warenkorb in einem Schritt zurueck.
    function addFromForm(formData) {
      var id = String(formData.get('id') || '');
      var qty = parseInt(formData.get('quantity'), 10) || 1;
      root.classList.add('is-adding');
      open(true);
      var post = function (url, body) {
        return fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      };
      var addFresh = function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }).then(function (r) {
          if (!r.ok) {
            return r.json().catch(function () { return {}; }).then(function (d) {
              var err = new Error(d.description || d.message || '');
              err.shopify = true;
              throw err;
            });
          }
          return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (c) { return c.json(); });
        });
      };
      var known = lastCart ? Promise.resolve(lastCart) : (pendingRefresh || refresh()).then(function () { return lastCart; });
      pendingRefresh = known
        .then(function (cart) {
          var line = packOptions.length && cart && (cart.items || []).filter(function (it) {
            return String(it.variant_id) === id;
          })[0];
          if (!line) return addFresh();
          return post('/cart/change.js', { id: line.key, quantity: qty }).then(function (r) {
            if (!r.ok) return addFresh();
            // Der gemerkte Warenkorb kann veraltet sein (z. B. in einem anderen Tab geleert).
            // Fehlt die Zeile danach, normal hinzufügen.
            return r.json().then(function (c) {
              var hit = (c.items || []).some(function (it) { return String(it.variant_id) === id; });
              return hit ? c : addFresh();
            });
          });
        })
        .then(ensureOfferCode)
        .then(function (cart) {
          lastCart = cart;
          render(cart);
          if (cart && cart.item_count > 0) restartReserve();
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: false }));
          return cart;
        })
        .catch(function (e) {
          console.error(e);
          alert((e && e.shopify && e.message) || 'Der Artikel konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.');
          refresh();
          return null;
        })
        .finally(function () { root.classList.remove('is-adding'); });
      return pendingRefresh;
    }
    window.fnCartDrawer = { add: addFromForm, open: open };

    // Keep contents live whenever the cart changes elsewhere.
    window.addEventListener('cart:updated', function (e) {
      if (e.detail) { lastCart = e.detail; render(e.detail); }
      else refresh();
    });

    // Prime counts on load (no fetch needed if header already has the count).
    if (pageMode) open(); else refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["functions-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var bar = document.querySelector('[data-fn-sticky-atc]');
    if (!bar) return;
    var root = document.querySelector('[data-functions-product]');
    if (!root) { bar.remove(); return; }
    var form = root.querySelector('form[data-add-to-cart-form]');
    var wraps = Array.prototype.slice.call(root.querySelectorAll('[data-variant-wrap]'));
    var opts = bar.querySelector('[data-sticky-opts]');
    if (!wraps.length || !form || !opts) { bar.remove(); return; }

    var goLabel = (bar.getAttribute('data-go-label') || '').trim();

    function esc(str) {
      return String(str || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function text(w, selectors) {
      for (var i = 0; i < selectors.length; i++) {
        var el = w.querySelector(selectors[i]);
        if (el && el.textContent.trim()) return el.textContent.trim();
      }
      return '';
    }

    // "€ 49,95" -> 49.95 (Tausenderpunkt, Dezimalkomma).
    function num(str) {
      var m = String(str || '').match(/\d[\d.,]*/);
      if (!m) return 0;
      return parseFloat(m[0].replace(/\.(?=\d{3}\b)/g, '').replace(',', '.')) || 0;
    }

    // Eine Kachel pro Hero-Paket. Name, Preis und Streichpreis stehen in der
    // Paketkarte; das Label ueber der Kachel kommt aus data-sticky-tag des
    // Paket-Blocks. [pct] wird aus Streich- und Paketpreis gerechnet.
    opts.innerHTML = wraps.map(function (w, i) {
      var name = text(w, ['.fw-plan__name', '.fn2-phero__name', '.fn-variant__title']);
      var price = w.getAttribute('data-variant-price') || text(w, ['.fw-plan__price']);
      var was = text(w, ['.fw-plan__compare']);
      if (was && num(was) <= num(price)) was = '';
      var tag = (w.getAttribute('data-sticky-tag') || '').trim();
      if (tag.indexOf('[pct]') > -1) {
        var pct = was ? Math.round((1 - num(price) / num(was)) * 100) : 0;
        tag = pct > 0 ? tag.replace('[pct]', pct) : '';
      }
      var featured = bar.hasAttribute('data-highlight') && w.hasAttribute('data-variant-default');
      return '<button type="button" class="fn-sticky-atc__opt' + (featured ? ' is-featured' : '') + '" data-sticky-opt="' + i + '"' +
          ' aria-label="' + esc(name + ', ' + price + (goLabel ? ' – ' + goLabel : '')) + '">' +
          (tag ? '<span class="fn-sticky-atc__opt-tag" aria-hidden="true">' + esc(tag) + '</span>' : '') +
          '<span class="fn-sticky-atc__opt-body" aria-hidden="true">' +
            '<span class="fn-sticky-atc__opt-name">' + esc(name) + '</span>' +
            '<span class="fn-sticky-atc__opt-prices">' +
              (was ? '<s class="fn-sticky-atc__opt-was">' + esc(was) + '</s>' : '') +
              '<span class="fn-sticky-atc__opt-price">' + esc(price) + '</span>' +
            '</span>' +
          '</span>' +
          '<span class="fn-sticky-atc__opt-go" aria-hidden="true"><svg viewBox="0 0 16 16" fill="none"><path d="M3 8h9M8.5 4l4 4-4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        '</button>';
    }).join('');

    // Ein Tipp waehlt das Paket im Hero (gleicher Code-Pfad wie ein Klick auf
    // die Karte, setzt Menge + Variante) und schickt dann das Hero-Formular
    // ab – das oeffnet den Warenkorb.
    opts.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sticky-opt]');
      if (!btn || btn.classList.contains('is-busy')) return;
      var w = wraps[parseInt(btn.getAttribute('data-sticky-opt'), 10)];
      var card = w && w.querySelector('[data-variant-card]');
      if (!card) return;
      btn.classList.add('is-busy');
      // card.click() setzt Variante und Menge synchron – sofort abschicken.
      card.click();
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      setTimeout(function () { btn.classList.remove('is-busy'); }, 800);
    });

    bar.hidden = false;
    bar.classList.add('is-visible');

    // Desktop reveal: only slide in once the hero add-to-cart is off screen,
    // so the bar never sits on top of the button it duplicates. On mobile the
    // CSS ignores `is-stuck` and the bar stays permanent.
    if (bar.classList.contains('fn-sticky-atc--reveal') && window.IntersectionObserver) {
      var anchor = form.querySelector('[data-add-to-cart]') || form;
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-stuck', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -40px 0px' }).observe(anchor);

      // Keep the bar reachable while it is selected in the theme editor.
      document.addEventListener('shopify:section:select', function (e) {
        if (bar.closest('.shopify-section') === e.target) bar.classList.add('is-stuck');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
